// This file is auto-generated by @hey-api/openapi-ts

import {
  type DefaultError,
  type InfiniteData,
  infiniteQueryOptions,
  queryOptions,
  type UseMutationOptions,
} from "@tanstack/react-query";

import { client } from "../client.gen";
import {
  acceptInvitation,
  acquireLock,
  activateCustomService,
  addShotAsset,
  answerInferenceQuestion,
  approveAsset,
  cancelExecution,
  cancelLoraTrainingRun,
  cancelTimelineExport,
  clearCompletedTimelineExports,
  confirmAssetUpload,
  createCredential,
  createCustomService,
  createDerivedAsset,
  createLora,
  createProject,
  createScene,
  createShot,
  createSignedCookies,
  createTeam,
  createTimeline,
  createTimelineExport,
  createTimelineLock,
  createTimelineVersion,
  createWorkflow,
  declineInvitation,
  deleteAsset,
  deleteCredential,
  deleteLora,
  deleteNotification,
  deleteProject,
  deleteScene,
  deleteShot,
  deleteTeam,
  deleteTimelineExport,
  deleteTimelineLock,
  deleteTimelineVersion,
  deleteVersion,
  deleteWorkflow,
  disableCustomService,
  duplicateWorkflow,
  executeWorkflow,
  generateFilmstrip,
  generateThumbnail,
  generateVideoChunks,
  getAsset,
  getCreativeDirection,
  getCurrentUser,
  getCustomService,
  getExecutionLogs,
  getExecutionStatus,
  getLora,
  getLoraDatasetPrep,
  getLoraTrainingRun,
  getNodeType,
  getNodeTypeParameters,
  getNotificationPreferences,
  getNotificationUnreadCount,
  getProject,
  getProjectApplicableEntitlementPolicies,
  getProjectTimelines,
  getScenes,
  getSearchFilters,
  getShot,
  getShotAssets,
  getShotAudit,
  getShotNodeDetail,
  getShotNodes,
  getTeam,
  getTimeline,
  getTimelineExport,
  getTimelineVersion,
  getVersion,
  getVersionHistory,
  getWorkflow,
  getWorkflowTemplates,
  googleLogin,
  grantProjectSupportAccess,
  initiateAssetUpload,
  internalExpireLapsedSupportGrants,
  internalFinalizeTrainingRun,
  internalGetLora,
  internalGetLoraCheckpoint,
  internalGetTrainingRun,
  internalListNonTerminalTrainingRuns,
  internalRegisterCheckpoint,
  internalSetTrainingRunExternalJob,
  internalSetTrainingRunStatus,
  listAssets,
  listBinItems,
  listCredentials,
  listCustomServices,
  listDerivedAssets,
  listLocatorRules,
  listLoraBaseModels,
  listLoraCheckpoints,
  listLoraKinds,
  listLoras,
  listLoraTrainingRuns,
  listNodeTypes,
  listNotifications,
  listPendingInvitations,
  listProjects,
  listProjectShares,
  listTeams,
  listTimelineExports,
  listTimelineVersions,
  listWorkflowAssets,
  listWorkflowExecutions,
  listWorkflows,
  lockCreativeDirection,
  logout,
  logoutOtherSessions,
  markAllNotificationsRead,
  markNotificationRead,
  type Options,
  previewCustomService,
  purgeAsset,
  purgeProject,
  purgeTeam,
  purgeVersion,
  purgeWorkflow,
  refreshToken,
  releaseLock,
  removeShotAsset,
  reorderScenes,
  reorderShots,
  resolveInvitationToken,
  restoreVersion,
  retryExecution,
  revokeProjectShare,
  revokeProjectSupportAccess,
  runShotNode,
  search,
  setDefaultCheckpoint,
  setWorkflowShotTemplate,
  shareProject,
  startCustomServiceInference,
  startLoraDatasetPrep,
  submitLoraTrainingRun,
  transferLoraToTeam,
  transferLoraToUser,
  unapproveAsset,
  undeleteAsset,
  undeleteProject,
  undeleteTeam,
  undeleteVersion,
  undeleteWorkflow,
  unlockCreativeDirection,
  updateAsset,
  updateCreativeDirection,
  updateCustomService,
  updateDerivedAssetStatus,
  updateLora,
  updateLoraDatasetCaption,
  updateNotificationPreferences,
  updateProject,
  updateProjectShareRole,
  updateScene,
  updateShot,
  updateShotNode,
  updateTeam,
  updateTimeline,
  updateWorkflow,
  uploadAsset,
  withdrawProjectInvitation,
} from "../sdk.gen";
import type {
  AcceptInvitationData,
  AcceptInvitationError,
  AcceptInvitationResponse,
  AcquireLockData,
  AcquireLockError,
  AcquireLockResponse,
  ActivateCustomServiceData,
  ActivateCustomServiceError,
  ActivateCustomServiceResponse,
  AddShotAssetData,
  AddShotAssetError,
  AddShotAssetResponse,
  AnswerInferenceQuestionData,
  AnswerInferenceQuestionError,
  AnswerInferenceQuestionResponse2,
  ApproveAssetData,
  ApproveAssetError,
  ApproveAssetResponse,
  CancelExecutionData,
  CancelExecutionResponse,
  CancelLoraTrainingRunData,
  CancelLoraTrainingRunError,
  CancelLoraTrainingRunResponse,
  CancelTimelineExportData,
  CancelTimelineExportError,
  CancelTimelineExportResponse,
  ClearCompletedTimelineExportsData,
  ClearCompletedTimelineExportsError,
  ClearCompletedTimelineExportsResponse,
  ConfirmAssetUploadData,
  ConfirmAssetUploadError,
  ConfirmAssetUploadResponse,
  CreateCredentialData,
  CreateCredentialError,
  CreateCredentialResponse2,
  CreateCustomServiceData,
  CreateCustomServiceError,
  CreateCustomServiceResponse2,
  CreateDerivedAssetData,
  CreateDerivedAssetError,
  CreateDerivedAssetResponse,
  CreateLoraData,
  CreateLoraError,
  CreateLoraResponse,
  CreateProjectData,
  CreateProjectError,
  CreateProjectResponse,
  CreateSceneData,
  CreateSceneError,
  CreateSceneResponse,
  CreateShotData,
  CreateShotError,
  CreateShotResponse,
  CreateSignedCookiesData,
  CreateSignedCookiesError,
  CreateSignedCookiesResponse,
  CreateTeamData,
  CreateTeamError,
  CreateTeamResponse,
  CreateTimelineData,
  CreateTimelineError,
  CreateTimelineExportData,
  CreateTimelineExportError,
  CreateTimelineExportResponse,
  CreateTimelineLockData,
  CreateTimelineLockError,
  CreateTimelineLockResponse,
  CreateTimelineResponse,
  CreateTimelineVersionData,
  CreateTimelineVersionError,
  CreateTimelineVersionResponse,
  CreateWorkflowData,
  CreateWorkflowError,
  CreateWorkflowResponse,
  DeclineInvitationData,
  DeclineInvitationError,
  DeclineInvitationResponse,
  DeleteAssetData,
  DeleteAssetError,
  DeleteAssetResponse,
  DeleteCredentialData,
  DeleteCredentialError,
  DeleteCredentialResponse2,
  DeleteLoraData,
  DeleteLoraError,
  DeleteLoraResponse,
  DeleteNotificationData,
  DeleteNotificationError,
  DeleteNotificationResponse,
  DeleteProjectData,
  DeleteProjectError,
  DeleteProjectResponse,
  DeleteSceneData,
  DeleteSceneError,
  DeleteSceneResponse,
  DeleteShotData,
  DeleteShotError,
  DeleteShotResponse,
  DeleteTeamData,
  DeleteTeamError,
  DeleteTeamResponse,
  DeleteTimelineExportData,
  DeleteTimelineExportError,
  DeleteTimelineExportResponse,
  DeleteTimelineLockData,
  DeleteTimelineLockError,
  DeleteTimelineLockResponse,
  DeleteTimelineVersionData,
  DeleteTimelineVersionError,
  DeleteTimelineVersionResponse,
  DeleteVersionData,
  DeleteVersionError,
  DeleteVersionResponse,
  DeleteWorkflowData,
  DeleteWorkflowError,
  DeleteWorkflowResponse,
  DisableCustomServiceData,
  DisableCustomServiceError,
  DisableCustomServiceResponse,
  DuplicateWorkflowData,
  DuplicateWorkflowError,
  DuplicateWorkflowResponse,
  ExecuteWorkflowData,
  ExecuteWorkflowError,
  ExecuteWorkflowResponse,
  GenerateFilmstripData,
  GenerateFilmstripError,
  GenerateFilmstripResponse2,
  GenerateThumbnailData,
  GenerateThumbnailError,
  GenerateThumbnailResponse2,
  GenerateVideoChunksData,
  GenerateVideoChunksError,
  GenerateVideoChunksResponse,
  GetAssetData,
  GetAssetError,
  GetAssetResponse,
  GetCreativeDirectionData,
  GetCreativeDirectionError,
  GetCreativeDirectionResponse,
  GetCurrentUserData,
  GetCurrentUserError,
  GetCurrentUserResponse,
  GetCustomServiceData,
  GetCustomServiceError,
  GetCustomServiceResponse,
  GetExecutionLogsData,
  GetExecutionLogsResponse,
  GetExecutionStatusData,
  GetExecutionStatusResponse,
  GetLoraData,
  GetLoraDatasetPrepData,
  GetLoraDatasetPrepError,
  GetLoraDatasetPrepResponse,
  GetLoraError,
  GetLoraResponse,
  GetLoraTrainingRunData,
  GetLoraTrainingRunError,
  GetLoraTrainingRunResponse,
  GetNodeTypeData,
  GetNodeTypeParametersData,
  GetNodeTypeParametersResponse,
  GetNodeTypeResponse,
  GetNotificationPreferencesData,
  GetNotificationPreferencesError,
  GetNotificationPreferencesResponse,
  GetNotificationUnreadCountData,
  GetNotificationUnreadCountError,
  GetNotificationUnreadCountResponse,
  GetProjectApplicableEntitlementPoliciesData,
  GetProjectApplicableEntitlementPoliciesError,
  GetProjectApplicableEntitlementPoliciesResponse,
  GetProjectData,
  GetProjectError,
  GetProjectResponse,
  GetProjectTimelinesData,
  GetProjectTimelinesError,
  GetProjectTimelinesResponse,
  GetScenesData,
  GetScenesError,
  GetScenesResponse,
  GetSearchFiltersData,
  GetSearchFiltersError,
  GetSearchFiltersResponse,
  GetShotAssetsData,
  GetShotAssetsError,
  GetShotAssetsResponse,
  GetShotAuditData,
  GetShotAuditError,
  GetShotAuditResponse,
  GetShotData,
  GetShotError,
  GetShotNodeDetailData,
  GetShotNodeDetailError,
  GetShotNodeDetailResponse,
  GetShotNodesData,
  GetShotNodesError,
  GetShotNodesResponse,
  GetShotResponse,
  GetTeamData,
  GetTeamError,
  GetTeamResponse,
  GetTimelineData,
  GetTimelineError,
  GetTimelineExportData,
  GetTimelineExportError,
  GetTimelineExportResponse,
  GetTimelineResponse,
  GetTimelineVersionData,
  GetTimelineVersionError,
  GetTimelineVersionResponse,
  GetVersionData,
  GetVersionHistoryData,
  GetVersionHistoryResponse,
  GetVersionResponse,
  GetWorkflowData,
  GetWorkflowResponse,
  GetWorkflowTemplatesData,
  GetWorkflowTemplatesError,
  GetWorkflowTemplatesResponse,
  GoogleLoginData,
  GoogleLoginError,
  GoogleLoginResponse,
  GrantProjectSupportAccessData,
  GrantProjectSupportAccessError,
  GrantProjectSupportAccessResponse,
  InitiateAssetUploadData,
  InitiateAssetUploadError,
  InitiateAssetUploadResponse,
  InternalExpireLapsedSupportGrantsData,
  InternalExpireLapsedSupportGrantsError,
  InternalExpireLapsedSupportGrantsResponse,
  InternalFinalizeTrainingRunData,
  InternalFinalizeTrainingRunError,
  InternalFinalizeTrainingRunResponse,
  InternalGetLoraCheckpointData,
  InternalGetLoraCheckpointError,
  InternalGetLoraCheckpointResponse,
  InternalGetLoraData,
  InternalGetLoraError,
  InternalGetLoraResponse,
  InternalGetTrainingRunData,
  InternalGetTrainingRunError,
  InternalGetTrainingRunResponse,
  InternalListNonTerminalTrainingRunsData,
  InternalListNonTerminalTrainingRunsError,
  InternalListNonTerminalTrainingRunsResponse,
  InternalRegisterCheckpointData,
  InternalRegisterCheckpointError,
  InternalRegisterCheckpointResponse,
  InternalSetTrainingRunExternalJobData,
  InternalSetTrainingRunExternalJobError,
  InternalSetTrainingRunExternalJobResponse,
  InternalSetTrainingRunStatusData,
  InternalSetTrainingRunStatusError,
  InternalSetTrainingRunStatusResponse,
  ListAssetsData,
  ListAssetsError,
  ListAssetsResponse,
  ListBinItemsData,
  ListBinItemsError,
  ListBinItemsResponse,
  ListCredentialsData,
  ListCredentialsError,
  ListCredentialsResponse,
  ListCustomServicesData,
  ListCustomServicesError,
  ListCustomServicesResponse,
  ListDerivedAssetsData,
  ListDerivedAssetsError,
  ListDerivedAssetsResponse,
  ListLocatorRulesData,
  ListLocatorRulesError,
  ListLocatorRulesResponse,
  ListLoraBaseModelsData,
  ListLoraBaseModelsError,
  ListLoraBaseModelsResponse,
  ListLoraCheckpointsData,
  ListLoraCheckpointsError,
  ListLoraCheckpointsResponse,
  ListLoraKindsData,
  ListLoraKindsError,
  ListLoraKindsResponse,
  ListLorasData,
  ListLorasError,
  ListLorasResponse,
  ListLoraTrainingRunsData,
  ListLoraTrainingRunsError,
  ListLoraTrainingRunsResponse,
  ListNodeTypesData,
  ListNodeTypesResponse,
  ListNotificationsData,
  ListNotificationsError,
  ListNotificationsResponse,
  ListPendingInvitationsData,
  ListPendingInvitationsError,
  ListPendingInvitationsResponse,
  ListProjectsData,
  ListProjectsError,
  ListProjectSharesData,
  ListProjectSharesError,
  ListProjectSharesResponse,
  ListProjectsResponse,
  ListTeamsData,
  ListTeamsError,
  ListTeamsResponse,
  ListTimelineExportsData,
  ListTimelineExportsError,
  ListTimelineExportsResponse,
  ListTimelineVersionsData,
  ListTimelineVersionsError,
  ListTimelineVersionsResponse,
  ListWorkflowAssetsData,
  ListWorkflowAssetsError,
  ListWorkflowAssetsResponse,
  ListWorkflowExecutionsData,
  ListWorkflowExecutionsResponse,
  ListWorkflowsData,
  ListWorkflowsResponse,
  LockCreativeDirectionData,
  LockCreativeDirectionError,
  LockCreativeDirectionResponse,
  LogoutData,
  LogoutOtherSessionsData,
  LogoutOtherSessionsError,
  LogoutOtherSessionsResponse,
  LogoutResponse,
  MarkAllNotificationsReadData,
  MarkAllNotificationsReadError,
  MarkAllNotificationsReadResponse,
  MarkNotificationReadData,
  MarkNotificationReadError,
  MarkNotificationReadResponse,
  PreviewCustomServiceData,
  PreviewCustomServiceError,
  PreviewCustomServiceResponse2,
  PurgeAssetData,
  PurgeAssetError,
  PurgeAssetResponse,
  PurgeProjectData,
  PurgeProjectError,
  PurgeProjectResponse,
  PurgeTeamData,
  PurgeTeamError,
  PurgeTeamResponse,
  PurgeVersionData,
  PurgeVersionError,
  PurgeVersionResponse,
  PurgeWorkflowData,
  PurgeWorkflowError,
  PurgeWorkflowResponse,
  RefreshTokenData,
  RefreshTokenError,
  RefreshTokenResponse,
  ReleaseLockData,
  ReleaseLockResponse,
  RemoveShotAssetData,
  RemoveShotAssetError,
  RemoveShotAssetResponse,
  ReorderScenesData,
  ReorderScenesError,
  ReorderScenesResponse,
  ReorderShotsData,
  ReorderShotsError,
  ReorderShotsResponse,
  ResolveInvitationTokenData,
  ResolveInvitationTokenError,
  ResolveInvitationTokenResponse2,
  RestoreVersionData,
  RestoreVersionError,
  RestoreVersionResponse2,
  RetryExecutionData,
  RetryExecutionResponse,
  RevokeProjectShareData,
  RevokeProjectShareError,
  RevokeProjectShareResponse,
  RevokeProjectSupportAccessData,
  RevokeProjectSupportAccessError,
  RevokeProjectSupportAccessResponse,
  RunShotNodeData,
  RunShotNodeError,
  RunShotNodeResponse,
  SearchData,
  SearchError,
  SearchResponse,
  SetDefaultCheckpointData,
  SetDefaultCheckpointError,
  SetDefaultCheckpointResponse,
  SetWorkflowShotTemplateData,
  SetWorkflowShotTemplateError,
  SetWorkflowShotTemplateResponse,
  ShareProjectData,
  ShareProjectError,
  ShareProjectResponse2,
  StartCustomServiceInferenceData,
  StartCustomServiceInferenceError,
  StartCustomServiceInferenceResponse,
  StartLoraDatasetPrepData,
  StartLoraDatasetPrepError,
  StartLoraDatasetPrepResponse,
  SubmitLoraTrainingRunData,
  SubmitLoraTrainingRunError,
  SubmitLoraTrainingRunResponse,
  TransferLoraToTeamData,
  TransferLoraToTeamError,
  TransferLoraToTeamResponse,
  TransferLoraToUserData,
  TransferLoraToUserError,
  TransferLoraToUserResponse,
  UnapproveAssetData,
  UnapproveAssetError,
  UnapproveAssetResponse,
  UndeleteAssetData,
  UndeleteAssetError,
  UndeleteAssetResponse,
  UndeleteProjectData,
  UndeleteProjectError,
  UndeleteProjectResponse,
  UndeleteTeamData,
  UndeleteTeamError,
  UndeleteTeamResponse,
  UndeleteVersionData,
  UndeleteVersionError,
  UndeleteVersionResponse,
  UndeleteWorkflowData,
  UndeleteWorkflowError,
  UndeleteWorkflowResponse,
  UnlockCreativeDirectionData,
  UnlockCreativeDirectionError,
  UnlockCreativeDirectionResponse,
  UpdateAssetData,
  UpdateAssetError,
  UpdateAssetResponse2,
  UpdateCreativeDirectionData,
  UpdateCreativeDirectionError,
  UpdateCreativeDirectionResponse,
  UpdateCustomServiceData,
  UpdateCustomServiceError,
  UpdateCustomServiceResponse2,
  UpdateDerivedAssetStatusData,
  UpdateDerivedAssetStatusError,
  UpdateDerivedAssetStatusResponse,
  UpdateLoraData,
  UpdateLoraDatasetCaptionData,
  UpdateLoraDatasetCaptionError,
  UpdateLoraDatasetCaptionResponse,
  UpdateLoraError,
  UpdateLoraResponse,
  UpdateNotificationPreferencesData,
  UpdateNotificationPreferencesError,
  UpdateNotificationPreferencesResponse,
  UpdateProjectData,
  UpdateProjectError,
  UpdateProjectResponse,
  UpdateProjectShareRoleData,
  UpdateProjectShareRoleError,
  UpdateProjectShareRoleResponse,
  UpdateSceneData,
  UpdateSceneError,
  UpdateSceneResponse,
  UpdateShotData,
  UpdateShotError,
  UpdateShotNodeData,
  UpdateShotNodeError,
  UpdateShotNodeResponse,
  UpdateShotResponse,
  UpdateTeamData,
  UpdateTeamError,
  UpdateTeamResponse,
  UpdateTimelineData,
  UpdateTimelineError,
  UpdateTimelineResponse,
  UpdateWorkflowData,
  UpdateWorkflowResponse,
  UploadAssetData,
  UploadAssetError,
  UploadAssetResponse,
  WithdrawProjectInvitationData,
  WithdrawProjectInvitationError,
  WithdrawProjectInvitationResponse,
} from "../types.gen";

/**
 * Google OAuth login
 */
export const googleLoginMutation = (
  options?: Partial<Options<GoogleLoginData>>,
): UseMutationOptions<
  GoogleLoginResponse,
  GoogleLoginError,
  Options<GoogleLoginData>
> => {
  const mutationOptions: UseMutationOptions<
    GoogleLoginResponse,
    GoogleLoginError,
    Options<GoogleLoginData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await googleLogin({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Refresh access token
 */
export const refreshTokenMutation = (
  options?: Partial<Options<RefreshTokenData>>,
): UseMutationOptions<
  RefreshTokenResponse,
  RefreshTokenError,
  Options<RefreshTokenData>
> => {
  const mutationOptions: UseMutationOptions<
    RefreshTokenResponse,
    RefreshTokenError,
    Options<RefreshTokenData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await refreshToken({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * User logout
 */
export const logoutMutation = (
  options?: Partial<Options<LogoutData>>,
): UseMutationOptions<LogoutResponse, DefaultError, Options<LogoutData>> => {
  const mutationOptions: UseMutationOptions<
    LogoutResponse,
    DefaultError,
    Options<LogoutData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await logout({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Sign out all other sessions
 *
 * Terminates all sessions for the current user except the one making the request. This is a security feature enabling users to remotely log out from all other devices/browsers.
 */
export const logoutOtherSessionsMutation = (
  options?: Partial<Options<LogoutOtherSessionsData>>,
): UseMutationOptions<
  LogoutOtherSessionsResponse,
  LogoutOtherSessionsError,
  Options<LogoutOtherSessionsData>
> => {
  const mutationOptions: UseMutationOptions<
    LogoutOtherSessionsResponse,
    LogoutOtherSessionsError,
    Options<LogoutOtherSessionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await logoutOtherSessions({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, "baseUrl" | "body" | "headers" | "path" | "query"> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl:
      options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const getCurrentUserQueryKey = (options?: Options<GetCurrentUserData>) =>
  createQueryKey("getCurrentUser", options);

/**
 * Get current user details
 */
export const getCurrentUserOptions = (options?: Options<GetCurrentUserData>) =>
  queryOptions<
    GetCurrentUserResponse,
    GetCurrentUserError,
    GetCurrentUserResponse,
    ReturnType<typeof getCurrentUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCurrentUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCurrentUserQueryKey(options),
  });

export const listTeamsQueryKey = (options?: Options<ListTeamsData>) =>
  createQueryKey("listTeams", options);

/**
 * List user's teams
 */
export const listTeamsOptions = (options?: Options<ListTeamsData>) =>
  queryOptions<
    ListTeamsResponse,
    ListTeamsError,
    ListTeamsResponse,
    ReturnType<typeof listTeamsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listTeams({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listTeamsQueryKey(options),
  });

/**
 * Create new team
 */
export const createTeamMutation = (
  options?: Partial<Options<CreateTeamData>>,
): UseMutationOptions<
  CreateTeamResponse,
  CreateTeamError,
  Options<CreateTeamData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateTeamResponse,
    CreateTeamError,
    Options<CreateTeamData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createTeam({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete team (soft delete)
 */
export const deleteTeamMutation = (
  options?: Partial<Options<DeleteTeamData>>,
): UseMutationOptions<
  DeleteTeamResponse,
  DeleteTeamError,
  Options<DeleteTeamData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteTeamResponse,
    DeleteTeamError,
    Options<DeleteTeamData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteTeam({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getTeamQueryKey = (options: Options<GetTeamData>) =>
  createQueryKey("getTeam", options);

/**
 * Get team details
 */
export const getTeamOptions = (options: Options<GetTeamData>) =>
  queryOptions<
    GetTeamResponse,
    GetTeamError,
    GetTeamResponse,
    ReturnType<typeof getTeamQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTeam({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTeamQueryKey(options),
  });

/**
 * Update team
 */
export const updateTeamMutation = (
  options?: Partial<Options<UpdateTeamData>>,
): UseMutationOptions<
  UpdateTeamResponse,
  UpdateTeamError,
  Options<UpdateTeamData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateTeamResponse,
    UpdateTeamError,
    Options<UpdateTeamData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateTeam({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Restore soft-deleted team
 */
export const undeleteTeamMutation = (
  options?: Partial<Options<UndeleteTeamData>>,
): UseMutationOptions<
  UndeleteTeamResponse,
  UndeleteTeamError,
  Options<UndeleteTeamData>
> => {
  const mutationOptions: UseMutationOptions<
    UndeleteTeamResponse,
    UndeleteTeamError,
    Options<UndeleteTeamData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await undeleteTeam({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Permanently delete team
 */
export const purgeTeamMutation = (
  options?: Partial<Options<PurgeTeamData>>,
): UseMutationOptions<
  PurgeTeamResponse,
  PurgeTeamError,
  Options<PurgeTeamData>
> => {
  const mutationOptions: UseMutationOptions<
    PurgeTeamResponse,
    PurgeTeamError,
    Options<PurgeTeamData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await purgeTeam({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listProjectsQueryKey = (options?: Options<ListProjectsData>) =>
  createQueryKey("listProjects", options);

/**
 * List user's accessible projects
 */
export const listProjectsOptions = (options?: Options<ListProjectsData>) =>
  queryOptions<
    ListProjectsResponse,
    ListProjectsError,
    ListProjectsResponse,
    ReturnType<typeof listProjectsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listProjects({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listProjectsQueryKey(options),
  });

const createInfiniteParams = <
  K extends Pick<QueryKey<Options>[0], "body" | "headers" | "path" | "query">,
>(
  queryKey: QueryKey<Options>,
  page: K,
) => {
  const params = { ...queryKey[0] };
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    };
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    };
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    };
  }
  return params as unknown as typeof page;
};

export const listProjectsInfiniteQueryKey = (
  options?: Options<ListProjectsData>,
): QueryKey<Options<ListProjectsData>> =>
  createQueryKey("listProjects", options, true);

/**
 * List user's accessible projects
 */
export const listProjectsInfiniteOptions = (
  options?: Options<ListProjectsData>,
) =>
  infiniteQueryOptions<
    ListProjectsResponse,
    ListProjectsError,
    InfiniteData<ListProjectsResponse>,
    QueryKey<Options<ListProjectsData>>,
    | number
    | Pick<
        QueryKey<Options<ListProjectsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListProjectsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listProjects({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listProjectsInfiniteQueryKey(options),
    },
  );

/**
 * Create project
 */
export const createProjectMutation = (
  options?: Partial<Options<CreateProjectData>>,
): UseMutationOptions<
  CreateProjectResponse,
  CreateProjectError,
  Options<CreateProjectData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateProjectResponse,
    CreateProjectError,
    Options<CreateProjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createProject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete project (soft delete)
 */
export const deleteProjectMutation = (
  options?: Partial<Options<DeleteProjectData>>,
): UseMutationOptions<
  DeleteProjectResponse,
  DeleteProjectError,
  Options<DeleteProjectData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteProjectResponse,
    DeleteProjectError,
    Options<DeleteProjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteProject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getProjectQueryKey = (options: Options<GetProjectData>) =>
  createQueryKey("getProject", options);

/**
 * Get project details
 */
export const getProjectOptions = (options: Options<GetProjectData>) =>
  queryOptions<
    GetProjectResponse,
    GetProjectError,
    GetProjectResponse,
    ReturnType<typeof getProjectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProjectQueryKey(options),
  });

/**
 * Update project
 */
export const updateProjectMutation = (
  options?: Partial<Options<UpdateProjectData>>,
): UseMutationOptions<
  UpdateProjectResponse,
  UpdateProjectError,
  Options<UpdateProjectData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateProjectResponse,
    UpdateProjectError,
    Options<UpdateProjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateProject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Restore soft-deleted project
 */
export const undeleteProjectMutation = (
  options?: Partial<Options<UndeleteProjectData>>,
): UseMutationOptions<
  UndeleteProjectResponse,
  UndeleteProjectError,
  Options<UndeleteProjectData>
> => {
  const mutationOptions: UseMutationOptions<
    UndeleteProjectResponse,
    UndeleteProjectError,
    Options<UndeleteProjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await undeleteProject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Permanently delete project
 */
export const purgeProjectMutation = (
  options?: Partial<Options<PurgeProjectData>>,
): UseMutationOptions<
  PurgeProjectResponse,
  PurgeProjectError,
  Options<PurgeProjectData>
> => {
  const mutationOptions: UseMutationOptions<
    PurgeProjectResponse,
    PurgeProjectError,
    Options<PurgeProjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await purgeProject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Get CloudFront signed cookies for project assets
 *
 * Emits three `Set-Cookie` headers (`CloudFront-Policy`, `CloudFront-Signature`,
 * `CloudFront-Key-Pair-Id`) as `HttpOnly; Secure; SameSite=Lax` cookies scoped
 * to the configured parent domain (e.g. `.stud1o.net`). The browser then sends
 * them automatically on asset requests to `assets.<env>`, so no signature
 * material appears in URL query strings.
 *
 * The response body returns `{ domain, expiresAt, projectPrefix }` only —
 * cookie values are NOT exposed to JavaScript.
 *
 */
export const createSignedCookiesMutation = (
  options?: Partial<Options<CreateSignedCookiesData>>,
): UseMutationOptions<
  CreateSignedCookiesResponse,
  CreateSignedCookiesError,
  Options<CreateSignedCookiesData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateSignedCookiesResponse,
    CreateSignedCookiesError,
    Options<CreateSignedCookiesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createSignedCookies({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getProjectApplicableEntitlementPoliciesQueryKey = (
  options: Options<GetProjectApplicableEntitlementPoliciesData>,
) => createQueryKey("getProjectApplicableEntitlementPolicies", options);

/**
 * List entitlement policies applicable to a project
 *
 * Returns the entitlement policies applicable to the given project
 * (org-scope, project-scope, and team-scope). Authorised via project
 * access (action__read__entitlement_policy + projectId), NOT org
 * membership — so team-only external users can read policies on
 * projects they have access to.
 *
 * See power #228 and docs/plans/entitlement-policy-consumer-read-api.md.
 *
 */
export const getProjectApplicableEntitlementPoliciesOptions = (
  options: Options<GetProjectApplicableEntitlementPoliciesData>,
) =>
  queryOptions<
    GetProjectApplicableEntitlementPoliciesResponse,
    GetProjectApplicableEntitlementPoliciesError,
    GetProjectApplicableEntitlementPoliciesResponse,
    ReturnType<typeof getProjectApplicableEntitlementPoliciesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjectApplicableEntitlementPolicies({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProjectApplicableEntitlementPoliciesQueryKey(options),
  });

export const listAssetsQueryKey = (options: Options<ListAssetsData>) =>
  createQueryKey("listAssets", options);

/**
 * List project's assets
 */
export const listAssetsOptions = (options: Options<ListAssetsData>) =>
  queryOptions<
    ListAssetsResponse,
    ListAssetsError,
    ListAssetsResponse,
    ReturnType<typeof listAssetsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAssets({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listAssetsQueryKey(options),
  });

export const listAssetsInfiniteQueryKey = (
  options: Options<ListAssetsData>,
): QueryKey<Options<ListAssetsData>> =>
  createQueryKey("listAssets", options, true);

/**
 * List project's assets
 */
export const listAssetsInfiniteOptions = (options: Options<ListAssetsData>) =>
  infiniteQueryOptions<
    ListAssetsResponse,
    ListAssetsError,
    InfiniteData<ListAssetsResponse>,
    QueryKey<Options<ListAssetsData>>,
    | number
    | Pick<
        QueryKey<Options<ListAssetsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListAssetsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listAssets({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listAssetsInfiniteQueryKey(options),
    },
  );

/**
 * Upload asset file to project
 */
export const uploadAssetMutation = (
  options?: Partial<Options<UploadAssetData>>,
): UseMutationOptions<
  UploadAssetResponse,
  UploadAssetError,
  Options<UploadAssetData>
> => {
  const mutationOptions: UseMutationOptions<
    UploadAssetResponse,
    UploadAssetError,
    Options<UploadAssetData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadAsset({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Initiate presigned URL upload for large files
 *
 * Initiates a presigned URL upload flow for large files (>10MB).
 * Returns a presigned S3 URL for direct upload, bypassing API body size limits.
 * After uploading to S3, call confirm-upload to finalize the asset.
 *
 */
export const initiateAssetUploadMutation = (
  options?: Partial<Options<InitiateAssetUploadData>>,
): UseMutationOptions<
  InitiateAssetUploadResponse,
  InitiateAssetUploadError,
  Options<InitiateAssetUploadData>
> => {
  const mutationOptions: UseMutationOptions<
    InitiateAssetUploadResponse,
    InitiateAssetUploadError,
    Options<InitiateAssetUploadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await initiateAssetUpload({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Confirm presigned URL upload
 *
 * Confirms that a file has been uploaded to S3 via presigned URL.
 * Verifies the file exists in S3 and transitions the asset to active status.
 *
 */
export const confirmAssetUploadMutation = (
  options?: Partial<Options<ConfirmAssetUploadData>>,
): UseMutationOptions<
  ConfirmAssetUploadResponse,
  ConfirmAssetUploadError,
  Options<ConfirmAssetUploadData>
> => {
  const mutationOptions: UseMutationOptions<
    ConfirmAssetUploadResponse,
    ConfirmAssetUploadError,
    Options<ConfirmAssetUploadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await confirmAssetUpload({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete asset (soft delete)
 */
export const deleteAssetMutation = (
  options?: Partial<Options<DeleteAssetData>>,
): UseMutationOptions<
  DeleteAssetResponse,
  DeleteAssetError,
  Options<DeleteAssetData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteAssetResponse,
    DeleteAssetError,
    Options<DeleteAssetData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteAsset({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getAssetQueryKey = (options: Options<GetAssetData>) =>
  createQueryKey("getAsset", options);

/**
 * Get asset details
 */
export const getAssetOptions = (options: Options<GetAssetData>) =>
  queryOptions<
    GetAssetResponse,
    GetAssetError,
    GetAssetResponse,
    ReturnType<typeof getAssetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAsset({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAssetQueryKey(options),
  });

/**
 * Update asset settings
 */
export const updateAssetMutation = (
  options?: Partial<Options<UpdateAssetData>>,
): UseMutationOptions<
  UpdateAssetResponse2,
  UpdateAssetError,
  Options<UpdateAssetData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateAssetResponse2,
    UpdateAssetError,
    Options<UpdateAssetData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateAsset({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Restore soft-deleted asset
 */
export const undeleteAssetMutation = (
  options?: Partial<Options<UndeleteAssetData>>,
): UseMutationOptions<
  UndeleteAssetResponse,
  UndeleteAssetError,
  Options<UndeleteAssetData>
> => {
  const mutationOptions: UseMutationOptions<
    UndeleteAssetResponse,
    UndeleteAssetError,
    Options<UndeleteAssetData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await undeleteAsset({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Permanently delete asset
 */
export const purgeAssetMutation = (
  options?: Partial<Options<PurgeAssetData>>,
): UseMutationOptions<
  PurgeAssetResponse,
  PurgeAssetError,
  Options<PurgeAssetData>
> => {
  const mutationOptions: UseMutationOptions<
    PurgeAssetResponse,
    PurgeAssetError,
    Options<PurgeAssetData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await purgeAsset({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listDerivedAssetsQueryKey = (
  options: Options<ListDerivedAssetsData>,
) => createQueryKey("listDerivedAssets", options);

/**
 * List derived assets for a parent asset
 */
export const listDerivedAssetsOptions = (
  options: Options<ListDerivedAssetsData>,
) =>
  queryOptions<
    ListDerivedAssetsResponse,
    ListDerivedAssetsError,
    ListDerivedAssetsResponse,
    ReturnType<typeof listDerivedAssetsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listDerivedAssets({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listDerivedAssetsQueryKey(options),
  });

/**
 * Create a derived asset group (internal/orchestrator)
 */
export const createDerivedAssetMutation = (
  options?: Partial<Options<CreateDerivedAssetData>>,
): UseMutationOptions<
  CreateDerivedAssetResponse,
  CreateDerivedAssetError,
  Options<CreateDerivedAssetData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateDerivedAssetResponse,
    CreateDerivedAssetError,
    Options<CreateDerivedAssetData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createDerivedAsset({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update derived asset processing status
 */
export const updateDerivedAssetStatusMutation = (
  options?: Partial<Options<UpdateDerivedAssetStatusData>>,
): UseMutationOptions<
  UpdateDerivedAssetStatusResponse,
  UpdateDerivedAssetStatusError,
  Options<UpdateDerivedAssetStatusData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateDerivedAssetStatusResponse,
    UpdateDerivedAssetStatusError,
    Options<UpdateDerivedAssetStatusData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateDerivedAssetStatus({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listLocatorRulesQueryKey = (
  options?: Options<ListLocatorRulesData>,
) => createQueryKey("listLocatorRules", options);

/**
 * List all active asset locator rules
 */
export const listLocatorRulesOptions = (
  options?: Options<ListLocatorRulesData>,
) =>
  queryOptions<
    ListLocatorRulesResponse,
    ListLocatorRulesError,
    ListLocatorRulesResponse,
    ReturnType<typeof listLocatorRulesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listLocatorRules({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listLocatorRulesQueryKey(options),
  });

/**
 * Generate video chunks from asset
 *
 * Creates a derived asset record and enqueues an FFmpeg chunking job
 * to the orchestrator for async processing. Returns 202 Accepted immediately.
 * The asset must be a video file.
 *
 */
export const generateVideoChunksMutation = (
  options?: Partial<Options<GenerateVideoChunksData>>,
): UseMutationOptions<
  GenerateVideoChunksResponse,
  GenerateVideoChunksError,
  Options<GenerateVideoChunksData>
> => {
  const mutationOptions: UseMutationOptions<
    GenerateVideoChunksResponse,
    GenerateVideoChunksError,
    Options<GenerateVideoChunksData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateVideoChunks({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Generate thumbnail from video asset
 *
 * Creates a derived asset record and enqueues an FFmpeg thumbnail job
 * to the orchestrator for async processing. Returns 202 Accepted immediately.
 * The asset must be a video file.
 *
 */
export const generateThumbnailMutation = (
  options?: Partial<Options<GenerateThumbnailData>>,
): UseMutationOptions<
  GenerateThumbnailResponse2,
  GenerateThumbnailError,
  Options<GenerateThumbnailData>
> => {
  const mutationOptions: UseMutationOptions<
    GenerateThumbnailResponse2,
    GenerateThumbnailError,
    Options<GenerateThumbnailData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateThumbnail({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Generate filmstrip sprite sheet from video asset
 *
 * Creates a derived asset record and enqueues an FFmpeg filmstrip job
 * to the orchestrator for async processing. Returns 202 Accepted immediately.
 * The asset must be a video file.
 *
 * A filmstrip is a horizontal sprite sheet containing evenly-spaced frames
 * from the video, useful for timeline scrubbing previews.
 *
 */
export const generateFilmstripMutation = (
  options?: Partial<Options<GenerateFilmstripData>>,
): UseMutationOptions<
  GenerateFilmstripResponse2,
  GenerateFilmstripError,
  Options<GenerateFilmstripData>
> => {
  const mutationOptions: UseMutationOptions<
    GenerateFilmstripResponse2,
    GenerateFilmstripError,
    Options<GenerateFilmstripData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateFilmstrip({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listWorkflowsQueryKey = (options: Options<ListWorkflowsData>) =>
  createQueryKey("listWorkflows", options);

/**
 * List workflows in a project
 */
export const listWorkflowsOptions = (options: Options<ListWorkflowsData>) =>
  queryOptions<
    ListWorkflowsResponse,
    DefaultError,
    ListWorkflowsResponse,
    ReturnType<typeof listWorkflowsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listWorkflows({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listWorkflowsQueryKey(options),
  });

export const listWorkflowsInfiniteQueryKey = (
  options: Options<ListWorkflowsData>,
): QueryKey<Options<ListWorkflowsData>> =>
  createQueryKey("listWorkflows", options, true);

/**
 * List workflows in a project
 */
export const listWorkflowsInfiniteOptions = (
  options: Options<ListWorkflowsData>,
) =>
  infiniteQueryOptions<
    ListWorkflowsResponse,
    DefaultError,
    InfiniteData<ListWorkflowsResponse>,
    QueryKey<Options<ListWorkflowsData>>,
    | number
    | Pick<
        QueryKey<Options<ListWorkflowsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListWorkflowsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listWorkflows({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listWorkflowsInfiniteQueryKey(options),
    },
  );

/**
 * Create a new workflow
 */
export const createWorkflowMutation = (
  options?: Partial<Options<CreateWorkflowData>>,
): UseMutationOptions<
  CreateWorkflowResponse,
  CreateWorkflowError,
  Options<CreateWorkflowData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateWorkflowResponse,
    CreateWorkflowError,
    Options<CreateWorkflowData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createWorkflow({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete workflow (soft delete)
 */
export const deleteWorkflowMutation = (
  options?: Partial<Options<DeleteWorkflowData>>,
): UseMutationOptions<
  DeleteWorkflowResponse,
  DeleteWorkflowError,
  Options<DeleteWorkflowData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteWorkflowResponse,
    DeleteWorkflowError,
    Options<DeleteWorkflowData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteWorkflow({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getWorkflowQueryKey = (options: Options<GetWorkflowData>) =>
  createQueryKey("getWorkflow", options);

/**
 * Get workflow details
 */
export const getWorkflowOptions = (options: Options<GetWorkflowData>) =>
  queryOptions<
    GetWorkflowResponse,
    DefaultError,
    GetWorkflowResponse,
    ReturnType<typeof getWorkflowQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWorkflow({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getWorkflowQueryKey(options),
  });

/**
 * Update workflow
 */
export const updateWorkflowMutation = (
  options?: Partial<Options<UpdateWorkflowData>>,
): UseMutationOptions<
  UpdateWorkflowResponse,
  DefaultError,
  Options<UpdateWorkflowData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateWorkflowResponse,
    DefaultError,
    Options<UpdateWorkflowData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateWorkflow({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Restore soft-deleted workflow
 */
export const undeleteWorkflowMutation = (
  options?: Partial<Options<UndeleteWorkflowData>>,
): UseMutationOptions<
  UndeleteWorkflowResponse,
  UndeleteWorkflowError,
  Options<UndeleteWorkflowData>
> => {
  const mutationOptions: UseMutationOptions<
    UndeleteWorkflowResponse,
    UndeleteWorkflowError,
    Options<UndeleteWorkflowData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await undeleteWorkflow({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Permanently delete workflow
 */
export const purgeWorkflowMutation = (
  options?: Partial<Options<PurgeWorkflowData>>,
): UseMutationOptions<
  PurgeWorkflowResponse,
  PurgeWorkflowError,
  Options<PurgeWorkflowData>
> => {
  const mutationOptions: UseMutationOptions<
    PurgeWorkflowResponse,
    PurgeWorkflowError,
    Options<PurgeWorkflowData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await purgeWorkflow({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Duplicate workflow
 */
export const duplicateWorkflowMutation = (
  options?: Partial<Options<DuplicateWorkflowData>>,
): UseMutationOptions<
  DuplicateWorkflowResponse,
  DuplicateWorkflowError,
  Options<DuplicateWorkflowData>
> => {
  const mutationOptions: UseMutationOptions<
    DuplicateWorkflowResponse,
    DuplicateWorkflowError,
    Options<DuplicateWorkflowData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await duplicateWorkflow({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getVersionHistoryQueryKey = (
  options: Options<GetVersionHistoryData>,
) => createQueryKey("getVersionHistory", options);

/**
 * Get version history
 */
export const getVersionHistoryOptions = (
  options: Options<GetVersionHistoryData>,
) =>
  queryOptions<
    GetVersionHistoryResponse,
    DefaultError,
    GetVersionHistoryResponse,
    ReturnType<typeof getVersionHistoryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getVersionHistory({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getVersionHistoryQueryKey(options),
  });

export const getVersionHistoryInfiniteQueryKey = (
  options: Options<GetVersionHistoryData>,
): QueryKey<Options<GetVersionHistoryData>> =>
  createQueryKey("getVersionHistory", options, true);

/**
 * Get version history
 */
export const getVersionHistoryInfiniteOptions = (
  options: Options<GetVersionHistoryData>,
) =>
  infiniteQueryOptions<
    GetVersionHistoryResponse,
    DefaultError,
    InfiniteData<GetVersionHistoryResponse>,
    QueryKey<Options<GetVersionHistoryData>>,
    | number
    | Pick<
        QueryKey<Options<GetVersionHistoryData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetVersionHistoryData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getVersionHistory({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getVersionHistoryInfiniteQueryKey(options),
    },
  );

/**
 * Delete version (soft delete)
 */
export const deleteVersionMutation = (
  options?: Partial<Options<DeleteVersionData>>,
): UseMutationOptions<
  DeleteVersionResponse,
  DeleteVersionError,
  Options<DeleteVersionData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteVersionResponse,
    DeleteVersionError,
    Options<DeleteVersionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteVersion({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getVersionQueryKey = (options: Options<GetVersionData>) =>
  createQueryKey("getVersion", options);

/**
 * Get specific version
 */
export const getVersionOptions = (options: Options<GetVersionData>) =>
  queryOptions<
    GetVersionResponse,
    DefaultError,
    GetVersionResponse,
    ReturnType<typeof getVersionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getVersion({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getVersionQueryKey(options),
  });

/**
 * Restore version (promote to current)
 */
export const restoreVersionMutation = (
  options?: Partial<Options<RestoreVersionData>>,
): UseMutationOptions<
  RestoreVersionResponse2,
  RestoreVersionError,
  Options<RestoreVersionData>
> => {
  const mutationOptions: UseMutationOptions<
    RestoreVersionResponse2,
    RestoreVersionError,
    Options<RestoreVersionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await restoreVersion({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Restore soft-deleted version
 */
export const undeleteVersionMutation = (
  options?: Partial<Options<UndeleteVersionData>>,
): UseMutationOptions<
  UndeleteVersionResponse,
  UndeleteVersionError,
  Options<UndeleteVersionData>
> => {
  const mutationOptions: UseMutationOptions<
    UndeleteVersionResponse,
    UndeleteVersionError,
    Options<UndeleteVersionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await undeleteVersion({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Permanently delete version
 */
export const purgeVersionMutation = (
  options?: Partial<Options<PurgeVersionData>>,
): UseMutationOptions<
  PurgeVersionResponse,
  PurgeVersionError,
  Options<PurgeVersionData>
> => {
  const mutationOptions: UseMutationOptions<
    PurgeVersionResponse,
    PurgeVersionError,
    Options<PurgeVersionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await purgeVersion({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Release workflow lock
 */
export const releaseLockMutation = (
  options?: Partial<Options<ReleaseLockData>>,
): UseMutationOptions<
  ReleaseLockResponse,
  DefaultError,
  Options<ReleaseLockData>
> => {
  const mutationOptions: UseMutationOptions<
    ReleaseLockResponse,
    DefaultError,
    Options<ReleaseLockData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await releaseLock({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Acquire or renew workflow lock
 */
export const acquireLockMutation = (
  options?: Partial<Options<AcquireLockData>>,
): UseMutationOptions<
  AcquireLockResponse,
  AcquireLockError,
  Options<AcquireLockData>
> => {
  const mutationOptions: UseMutationOptions<
    AcquireLockResponse,
    AcquireLockError,
    Options<AcquireLockData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await acquireLock({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listNodeTypesQueryKey = (options?: Options<ListNodeTypesData>) =>
  createQueryKey("listNodeTypes", options);

/**
 * List node types
 */
export const listNodeTypesOptions = (options?: Options<ListNodeTypesData>) =>
  queryOptions<
    ListNodeTypesResponse,
    DefaultError,
    ListNodeTypesResponse,
    ReturnType<typeof listNodeTypesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listNodeTypes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listNodeTypesQueryKey(options),
  });

export const listNodeTypesInfiniteQueryKey = (
  options?: Options<ListNodeTypesData>,
): QueryKey<Options<ListNodeTypesData>> =>
  createQueryKey("listNodeTypes", options, true);

/**
 * List node types
 */
export const listNodeTypesInfiniteOptions = (
  options?: Options<ListNodeTypesData>,
) =>
  infiniteQueryOptions<
    ListNodeTypesResponse,
    DefaultError,
    InfiniteData<ListNodeTypesResponse>,
    QueryKey<Options<ListNodeTypesData>>,
    | number
    | Pick<
        QueryKey<Options<ListNodeTypesData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListNodeTypesData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listNodeTypes({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listNodeTypesInfiniteQueryKey(options),
    },
  );

export const getNodeTypeQueryKey = (options: Options<GetNodeTypeData>) =>
  createQueryKey("getNodeType", options);

/**
 * Get node type details
 */
export const getNodeTypeOptions = (options: Options<GetNodeTypeData>) =>
  queryOptions<
    GetNodeTypeResponse,
    DefaultError,
    GetNodeTypeResponse,
    ReturnType<typeof getNodeTypeQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getNodeType({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getNodeTypeQueryKey(options),
  });

export const getNodeTypeParametersQueryKey = (
  options: Options<GetNodeTypeParametersData>,
) => createQueryKey("getNodeTypeParameters", options);

/**
 * Get node type parameters
 */
export const getNodeTypeParametersOptions = (
  options: Options<GetNodeTypeParametersData>,
) =>
  queryOptions<
    GetNodeTypeParametersResponse,
    DefaultError,
    GetNodeTypeParametersResponse,
    ReturnType<typeof getNodeTypeParametersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getNodeTypeParameters({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getNodeTypeParametersQueryKey(options),
  });

/**
 * Execute full workflow
 */
export const executeWorkflowMutation = (
  options?: Partial<Options<ExecuteWorkflowData>>,
): UseMutationOptions<
  ExecuteWorkflowResponse,
  ExecuteWorkflowError,
  Options<ExecuteWorkflowData>
> => {
  const mutationOptions: UseMutationOptions<
    ExecuteWorkflowResponse,
    ExecuteWorkflowError,
    Options<ExecuteWorkflowData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await executeWorkflow({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listWorkflowExecutionsQueryKey = (
  options: Options<ListWorkflowExecutionsData>,
) => createQueryKey("listWorkflowExecutions", options);

/**
 * List workflow executions
 */
export const listWorkflowExecutionsOptions = (
  options: Options<ListWorkflowExecutionsData>,
) =>
  queryOptions<
    ListWorkflowExecutionsResponse,
    DefaultError,
    ListWorkflowExecutionsResponse,
    ReturnType<typeof listWorkflowExecutionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listWorkflowExecutions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listWorkflowExecutionsQueryKey(options),
  });

export const listWorkflowExecutionsInfiniteQueryKey = (
  options: Options<ListWorkflowExecutionsData>,
): QueryKey<Options<ListWorkflowExecutionsData>> =>
  createQueryKey("listWorkflowExecutions", options, true);

/**
 * List workflow executions
 */
export const listWorkflowExecutionsInfiniteOptions = (
  options: Options<ListWorkflowExecutionsData>,
) =>
  infiniteQueryOptions<
    ListWorkflowExecutionsResponse,
    DefaultError,
    InfiniteData<ListWorkflowExecutionsResponse>,
    QueryKey<Options<ListWorkflowExecutionsData>>,
    | number
    | Pick<
        QueryKey<Options<ListWorkflowExecutionsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListWorkflowExecutionsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listWorkflowExecutions({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listWorkflowExecutionsInfiniteQueryKey(options),
    },
  );

export const listWorkflowAssetsQueryKey = (
  options: Options<ListWorkflowAssetsData>,
) => createQueryKey("listWorkflowAssets", options);

/**
 * List workflow's assets
 */
export const listWorkflowAssetsOptions = (
  options: Options<ListWorkflowAssetsData>,
) =>
  queryOptions<
    ListWorkflowAssetsResponse,
    ListWorkflowAssetsError,
    ListWorkflowAssetsResponse,
    ReturnType<typeof listWorkflowAssetsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listWorkflowAssets({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listWorkflowAssetsQueryKey(options),
  });

export const listWorkflowAssetsInfiniteQueryKey = (
  options: Options<ListWorkflowAssetsData>,
): QueryKey<Options<ListWorkflowAssetsData>> =>
  createQueryKey("listWorkflowAssets", options, true);

/**
 * List workflow's assets
 */
export const listWorkflowAssetsInfiniteOptions = (
  options: Options<ListWorkflowAssetsData>,
) =>
  infiniteQueryOptions<
    ListWorkflowAssetsResponse,
    ListWorkflowAssetsError,
    InfiniteData<ListWorkflowAssetsResponse>,
    QueryKey<Options<ListWorkflowAssetsData>>,
    | number
    | Pick<
        QueryKey<Options<ListWorkflowAssetsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListWorkflowAssetsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listWorkflowAssets({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listWorkflowAssetsInfiniteQueryKey(options),
    },
  );

export const getExecutionStatusQueryKey = (
  options: Options<GetExecutionStatusData>,
) => createQueryKey("getExecutionStatus", options);

/**
 * Get execution status
 */
export const getExecutionStatusOptions = (
  options: Options<GetExecutionStatusData>,
) =>
  queryOptions<
    GetExecutionStatusResponse,
    DefaultError,
    GetExecutionStatusResponse,
    ReturnType<typeof getExecutionStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getExecutionStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getExecutionStatusQueryKey(options),
  });

/**
 * Cancel execution
 */
export const cancelExecutionMutation = (
  options?: Partial<Options<CancelExecutionData>>,
): UseMutationOptions<
  CancelExecutionResponse,
  DefaultError,
  Options<CancelExecutionData>
> => {
  const mutationOptions: UseMutationOptions<
    CancelExecutionResponse,
    DefaultError,
    Options<CancelExecutionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await cancelExecution({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Retry failed execution
 */
export const retryExecutionMutation = (
  options?: Partial<Options<RetryExecutionData>>,
): UseMutationOptions<
  RetryExecutionResponse,
  DefaultError,
  Options<RetryExecutionData>
> => {
  const mutationOptions: UseMutationOptions<
    RetryExecutionResponse,
    DefaultError,
    Options<RetryExecutionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await retryExecution({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getExecutionLogsQueryKey = (
  options: Options<GetExecutionLogsData>,
) => createQueryKey("getExecutionLogs", options);

/**
 * Get execution logs
 */
export const getExecutionLogsOptions = (
  options: Options<GetExecutionLogsData>,
) =>
  queryOptions<
    GetExecutionLogsResponse,
    DefaultError,
    GetExecutionLogsResponse,
    ReturnType<typeof getExecutionLogsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getExecutionLogs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getExecutionLogsQueryKey(options),
  });

export const listProjectSharesQueryKey = (
  options: Options<ListProjectSharesData>,
) => createQueryKey("listProjectShares", options);

/**
 * List project shares and pending invitations
 *
 * Returns all teams that have access to the project (shares) and
 * all pending invitations that have not yet been accepted or declined.
 *
 */
export const listProjectSharesOptions = (
  options: Options<ListProjectSharesData>,
) =>
  queryOptions<
    ListProjectSharesResponse,
    ListProjectSharesError,
    ListProjectSharesResponse,
    ReturnType<typeof listProjectSharesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listProjectShares({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listProjectSharesQueryKey(options),
  });

/**
 * Share project with another user via email invitation
 *
 * Sends an email invitation to share the project with another user.
 * The invited user receives an email with a magic link to accept.
 *
 */
export const shareProjectMutation = (
  options?: Partial<Options<ShareProjectData>>,
): UseMutationOptions<
  ShareProjectResponse2,
  ShareProjectError,
  Options<ShareProjectData>
> => {
  const mutationOptions: UseMutationOptions<
    ShareProjectResponse2,
    ShareProjectError,
    Options<ShareProjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await shareProject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Revoke a team's access to a project
 *
 * Removes the specified team's access to the project. The team will
 * no longer be able to view or edit the project.
 *
 */
export const revokeProjectShareMutation = (
  options?: Partial<Options<RevokeProjectShareData>>,
): UseMutationOptions<
  RevokeProjectShareResponse,
  RevokeProjectShareError,
  Options<RevokeProjectShareData>
> => {
  const mutationOptions: UseMutationOptions<
    RevokeProjectShareResponse,
    RevokeProjectShareError,
    Options<RevokeProjectShareData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await revokeProjectShare({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update a team's role on a project share
 *
 * Changes the role assigned to a team for a given project share.
 * For example, promote a team from editor to owner, or demote from
 * owner to editor.
 *
 */
export const updateProjectShareRoleMutation = (
  options?: Partial<Options<UpdateProjectShareRoleData>>,
): UseMutationOptions<
  UpdateProjectShareRoleResponse,
  UpdateProjectShareRoleError,
  Options<UpdateProjectShareRoleData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateProjectShareRoleResponse,
    UpdateProjectShareRoleError,
    Options<UpdateProjectShareRoleData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateProjectShareRole({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Withdraw a pending invitation
 *
 * Cancels a pending invitation that was sent to share a project.
 * Only the project owner can withdraw invitations.
 *
 */
export const withdrawProjectInvitationMutation = (
  options?: Partial<Options<WithdrawProjectInvitationData>>,
): UseMutationOptions<
  WithdrawProjectInvitationResponse,
  WithdrawProjectInvitationError,
  Options<WithdrawProjectInvitationData>
> => {
  const mutationOptions: UseMutationOptions<
    WithdrawProjectInvitationResponse,
    WithdrawProjectInvitationError,
    Options<WithdrawProjectInvitationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await withdrawProjectInvitation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listPendingInvitationsQueryKey = (
  options?: Options<ListPendingInvitationsData>,
) => createQueryKey("listPendingInvitations", options);

/**
 * List current user's pending invitations
 *
 * Returns all pending project invitations for the authenticated user.
 * These are invitations that have been sent to the user's email address
 * and have not yet been accepted or declined.
 *
 */
export const listPendingInvitationsOptions = (
  options?: Options<ListPendingInvitationsData>,
) =>
  queryOptions<
    ListPendingInvitationsResponse,
    ListPendingInvitationsError,
    ListPendingInvitationsResponse,
    ReturnType<typeof listPendingInvitationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listPendingInvitations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listPendingInvitationsQueryKey(options),
  });

export const resolveInvitationTokenQueryKey = (
  options: Options<ResolveInvitationTokenData>,
) => createQueryKey("resolveInvitationToken", options);

/**
 * Resolve an invitation token (public, no auth required)
 *
 * Resolves an invitation token to its details (project name, inviter, role).
 * This endpoint is public so unauthenticated users can see invitation details
 * before logging in or signing up.
 *
 */
export const resolveInvitationTokenOptions = (
  options: Options<ResolveInvitationTokenData>,
) =>
  queryOptions<
    ResolveInvitationTokenResponse2,
    ResolveInvitationTokenError,
    ResolveInvitationTokenResponse2,
    ReturnType<typeof resolveInvitationTokenQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await resolveInvitationToken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: resolveInvitationTokenQueryKey(options),
  });

/**
 * Accept a project invitation
 *
 * Accepts a pending invitation, granting the user's team access to the
 * project with the specified role (editor or viewer).
 *
 */
export const acceptInvitationMutation = (
  options?: Partial<Options<AcceptInvitationData>>,
): UseMutationOptions<
  AcceptInvitationResponse,
  AcceptInvitationError,
  Options<AcceptInvitationData>
> => {
  const mutationOptions: UseMutationOptions<
    AcceptInvitationResponse,
    AcceptInvitationError,
    Options<AcceptInvitationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await acceptInvitation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Decline a project invitation
 *
 * Declines a pending invitation. The project will not be shared with
 * the user's team.
 *
 */
export const declineInvitationMutation = (
  options?: Partial<Options<DeclineInvitationData>>,
): UseMutationOptions<
  DeclineInvitationResponse,
  DeclineInvitationError,
  Options<DeclineInvitationData>
> => {
  const mutationOptions: UseMutationOptions<
    DeclineInvitationResponse,
    DeclineInvitationError,
    Options<DeclineInvitationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await declineInvitation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getProjectTimelinesQueryKey = (
  options: Options<GetProjectTimelinesData>,
) => createQueryKey("getProjectTimelines", options);

/**
 * List timelines in a project
 */
export const getProjectTimelinesOptions = (
  options: Options<GetProjectTimelinesData>,
) =>
  queryOptions<
    GetProjectTimelinesResponse,
    GetProjectTimelinesError,
    GetProjectTimelinesResponse,
    ReturnType<typeof getProjectTimelinesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjectTimelines({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProjectTimelinesQueryKey(options),
  });

export const getProjectTimelinesInfiniteQueryKey = (
  options: Options<GetProjectTimelinesData>,
): QueryKey<Options<GetProjectTimelinesData>> =>
  createQueryKey("getProjectTimelines", options, true);

/**
 * List timelines in a project
 */
export const getProjectTimelinesInfiniteOptions = (
  options: Options<GetProjectTimelinesData>,
) =>
  infiniteQueryOptions<
    GetProjectTimelinesResponse,
    GetProjectTimelinesError,
    InfiniteData<GetProjectTimelinesResponse>,
    QueryKey<Options<GetProjectTimelinesData>>,
    | number
    | Pick<
        QueryKey<Options<GetProjectTimelinesData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetProjectTimelinesData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getProjectTimelines({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getProjectTimelinesInfiniteQueryKey(options),
    },
  );

/**
 * Create a new timeline
 */
export const createTimelineMutation = (
  options?: Partial<Options<CreateTimelineData>>,
): UseMutationOptions<
  CreateTimelineResponse,
  CreateTimelineError,
  Options<CreateTimelineData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateTimelineResponse,
    CreateTimelineError,
    Options<CreateTimelineData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createTimeline({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getTimelineQueryKey = (options: Options<GetTimelineData>) =>
  createQueryKey("getTimeline", options);

/**
 * Get timeline details
 */
export const getTimelineOptions = (options: Options<GetTimelineData>) =>
  queryOptions<
    GetTimelineResponse,
    GetTimelineError,
    GetTimelineResponse,
    ReturnType<typeof getTimelineQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTimeline({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTimelineQueryKey(options),
  });

/**
 * Update timeline
 */
export const updateTimelineMutation = (
  options?: Partial<Options<UpdateTimelineData>>,
): UseMutationOptions<
  UpdateTimelineResponse,
  UpdateTimelineError,
  Options<UpdateTimelineData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateTimelineResponse,
    UpdateTimelineError,
    Options<UpdateTimelineData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateTimeline({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listTimelineVersionsQueryKey = (
  options: Options<ListTimelineVersionsData>,
) => createQueryKey("listTimelineVersions", options);

/**
 * List timeline versions
 */
export const listTimelineVersionsOptions = (
  options: Options<ListTimelineVersionsData>,
) =>
  queryOptions<
    ListTimelineVersionsResponse,
    ListTimelineVersionsError,
    ListTimelineVersionsResponse,
    ReturnType<typeof listTimelineVersionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listTimelineVersions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listTimelineVersionsQueryKey(options),
  });

export const listTimelineVersionsInfiniteQueryKey = (
  options: Options<ListTimelineVersionsData>,
): QueryKey<Options<ListTimelineVersionsData>> =>
  createQueryKey("listTimelineVersions", options, true);

/**
 * List timeline versions
 */
export const listTimelineVersionsInfiniteOptions = (
  options: Options<ListTimelineVersionsData>,
) =>
  infiniteQueryOptions<
    ListTimelineVersionsResponse,
    ListTimelineVersionsError,
    InfiniteData<ListTimelineVersionsResponse>,
    QueryKey<Options<ListTimelineVersionsData>>,
    | number
    | Pick<
        QueryKey<Options<ListTimelineVersionsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListTimelineVersionsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listTimelineVersions({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listTimelineVersionsInfiniteQueryKey(options),
    },
  );

/**
 * Create a new timeline version
 */
export const createTimelineVersionMutation = (
  options?: Partial<Options<CreateTimelineVersionData>>,
): UseMutationOptions<
  CreateTimelineVersionResponse,
  CreateTimelineVersionError,
  Options<CreateTimelineVersionData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateTimelineVersionResponse,
    CreateTimelineVersionError,
    Options<CreateTimelineVersionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createTimelineVersion({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete timeline version (soft delete)
 */
export const deleteTimelineVersionMutation = (
  options?: Partial<Options<DeleteTimelineVersionData>>,
): UseMutationOptions<
  DeleteTimelineVersionResponse,
  DeleteTimelineVersionError,
  Options<DeleteTimelineVersionData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteTimelineVersionResponse,
    DeleteTimelineVersionError,
    Options<DeleteTimelineVersionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteTimelineVersion({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getTimelineVersionQueryKey = (
  options: Options<GetTimelineVersionData>,
) => createQueryKey("getTimelineVersion", options);

/**
 * Get timeline version details
 */
export const getTimelineVersionOptions = (
  options: Options<GetTimelineVersionData>,
) =>
  queryOptions<
    GetTimelineVersionResponse,
    GetTimelineVersionError,
    GetTimelineVersionResponse,
    ReturnType<typeof getTimelineVersionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTimelineVersion({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTimelineVersionQueryKey(options),
  });

/**
 * Release timeline lock
 *
 * Releases the exclusive edit lock on a timeline held by the authenticated user.
 */
export const deleteTimelineLockMutation = (
  options?: Partial<Options<DeleteTimelineLockData>>,
): UseMutationOptions<
  DeleteTimelineLockResponse,
  DeleteTimelineLockError,
  Options<DeleteTimelineLockData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteTimelineLockResponse,
    DeleteTimelineLockError,
    Options<DeleteTimelineLockData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteTimelineLock({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Acquire timeline lock
 *
 * Acquires an exclusive edit lock on a timeline for the authenticated user.
 */
export const createTimelineLockMutation = (
  options?: Partial<Options<CreateTimelineLockData>>,
): UseMutationOptions<
  CreateTimelineLockResponse,
  CreateTimelineLockError,
  Options<CreateTimelineLockData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateTimelineLockResponse,
    CreateTimelineLockError,
    Options<CreateTimelineLockData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createTimelineLock({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create a timeline export
 *
 * Initiates a new timeline export job. The export is processed asynchronously and the response includes the export record with a queued status.
 */
export const createTimelineExportMutation = (
  options?: Partial<Options<CreateTimelineExportData>>,
): UseMutationOptions<
  CreateTimelineExportResponse,
  CreateTimelineExportError,
  Options<CreateTimelineExportData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateTimelineExportResponse,
    CreateTimelineExportError,
    Options<CreateTimelineExportData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createTimelineExport({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listTimelineExportsQueryKey = (
  options: Options<ListTimelineExportsData>,
) => createQueryKey("listTimelineExports", options);

/**
 * List timeline exports
 *
 * Returns a paginated list of exports for a specific timeline within a project.
 */
export const listTimelineExportsOptions = (
  options: Options<ListTimelineExportsData>,
) =>
  queryOptions<
    ListTimelineExportsResponse,
    ListTimelineExportsError,
    ListTimelineExportsResponse,
    ReturnType<typeof listTimelineExportsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listTimelineExports({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listTimelineExportsQueryKey(options),
  });

export const listTimelineExportsInfiniteQueryKey = (
  options: Options<ListTimelineExportsData>,
): QueryKey<Options<ListTimelineExportsData>> =>
  createQueryKey("listTimelineExports", options, true);

/**
 * List timeline exports
 *
 * Returns a paginated list of exports for a specific timeline within a project.
 */
export const listTimelineExportsInfiniteOptions = (
  options: Options<ListTimelineExportsData>,
) =>
  infiniteQueryOptions<
    ListTimelineExportsResponse,
    ListTimelineExportsError,
    InfiniteData<ListTimelineExportsResponse>,
    QueryKey<Options<ListTimelineExportsData>>,
    | number
    | Pick<
        QueryKey<Options<ListTimelineExportsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListTimelineExportsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listTimelineExports({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listTimelineExportsInfiniteQueryKey(options),
    },
  );

export const getTimelineExportQueryKey = (
  options: Options<GetTimelineExportData>,
) => createQueryKey("getTimelineExport", options);

/**
 * Get timeline export details
 *
 * Returns the details of a specific timeline export including its current status and progress.
 */
export const getTimelineExportOptions = (
  options: Options<GetTimelineExportData>,
) =>
  queryOptions<
    GetTimelineExportResponse,
    GetTimelineExportError,
    GetTimelineExportResponse,
    ReturnType<typeof getTimelineExportQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTimelineExport({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTimelineExportQueryKey(options),
  });

/**
 * Delete a timeline export
 *
 * Soft-deletes a timeline export. Only terminal-state exports (completed, failed, cancelled) can be deleted. In-progress exports must be cancelled first.
 */
export const deleteTimelineExportMutation = (
  options?: Partial<Options<DeleteTimelineExportData>>,
): UseMutationOptions<
  DeleteTimelineExportResponse,
  DeleteTimelineExportError,
  Options<DeleteTimelineExportData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteTimelineExportResponse,
    DeleteTimelineExportError,
    Options<DeleteTimelineExportData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteTimelineExport({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Cancel a timeline export
 *
 * Cancels a timeline export that is currently in progress or queued.
 */
export const cancelTimelineExportMutation = (
  options?: Partial<Options<CancelTimelineExportData>>,
): UseMutationOptions<
  CancelTimelineExportResponse,
  CancelTimelineExportError,
  Options<CancelTimelineExportData>
> => {
  const mutationOptions: UseMutationOptions<
    CancelTimelineExportResponse,
    CancelTimelineExportError,
    Options<CancelTimelineExportData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await cancelTimelineExport({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Clear completed timeline exports
 *
 * Soft-deletes all terminal-state exports (completed, failed, cancelled) for a timeline.
 */
export const clearCompletedTimelineExportsMutation = (
  options?: Partial<Options<ClearCompletedTimelineExportsData>>,
): UseMutationOptions<
  ClearCompletedTimelineExportsResponse,
  ClearCompletedTimelineExportsError,
  Options<ClearCompletedTimelineExportsData>
> => {
  const mutationOptions: UseMutationOptions<
    ClearCompletedTimelineExportsResponse,
    ClearCompletedTimelineExportsError,
    Options<ClearCompletedTimelineExportsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await clearCompletedTimelineExports({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listNotificationsQueryKey = (
  options?: Options<ListNotificationsData>,
) => createQueryKey("listNotifications", options);

/**
 * List notifications for the authenticated user
 *
 * Returns a paginated list of notifications for the current user.
 * Supports filtering by read status and category.
 *
 */
export const listNotificationsOptions = (
  options?: Options<ListNotificationsData>,
) =>
  queryOptions<
    ListNotificationsResponse,
    ListNotificationsError,
    ListNotificationsResponse,
    ReturnType<typeof listNotificationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listNotifications({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listNotificationsQueryKey(options),
  });

export const listNotificationsInfiniteQueryKey = (
  options?: Options<ListNotificationsData>,
): QueryKey<Options<ListNotificationsData>> =>
  createQueryKey("listNotifications", options, true);

/**
 * List notifications for the authenticated user
 *
 * Returns a paginated list of notifications for the current user.
 * Supports filtering by read status and category.
 *
 */
export const listNotificationsInfiniteOptions = (
  options?: Options<ListNotificationsData>,
) =>
  infiniteQueryOptions<
    ListNotificationsResponse,
    ListNotificationsError,
    InfiniteData<ListNotificationsResponse>,
    QueryKey<Options<ListNotificationsData>>,
    | number
    | Pick<
        QueryKey<Options<ListNotificationsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListNotificationsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listNotifications({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listNotificationsInfiniteQueryKey(options),
    },
  );

export const getNotificationUnreadCountQueryKey = (
  options?: Options<GetNotificationUnreadCountData>,
) => createQueryKey("getNotificationUnreadCount", options);

/**
 * Get unread notification count
 *
 * Returns the number of unread notifications for the authenticated user.
 */
export const getNotificationUnreadCountOptions = (
  options?: Options<GetNotificationUnreadCountData>,
) =>
  queryOptions<
    GetNotificationUnreadCountResponse,
    GetNotificationUnreadCountError,
    GetNotificationUnreadCountResponse,
    ReturnType<typeof getNotificationUnreadCountQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getNotificationUnreadCount({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getNotificationUnreadCountQueryKey(options),
  });

/**
 * Mark all notifications as read
 *
 * Marks all unread notifications as read for the authenticated user.
 */
export const markAllNotificationsReadMutation = (
  options?: Partial<Options<MarkAllNotificationsReadData>>,
): UseMutationOptions<
  MarkAllNotificationsReadResponse,
  MarkAllNotificationsReadError,
  Options<MarkAllNotificationsReadData>
> => {
  const mutationOptions: UseMutationOptions<
    MarkAllNotificationsReadResponse,
    MarkAllNotificationsReadError,
    Options<MarkAllNotificationsReadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await markAllNotificationsRead({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getNotificationPreferencesQueryKey = (
  options?: Options<GetNotificationPreferencesData>,
) => createQueryKey("getNotificationPreferences", options);

/**
 * Get notification preferences
 *
 * Returns the notification preferences for the authenticated user.
 */
export const getNotificationPreferencesOptions = (
  options?: Options<GetNotificationPreferencesData>,
) =>
  queryOptions<
    GetNotificationPreferencesResponse,
    GetNotificationPreferencesError,
    GetNotificationPreferencesResponse,
    ReturnType<typeof getNotificationPreferencesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getNotificationPreferences({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getNotificationPreferencesQueryKey(options),
  });

/**
 * Update notification preferences
 *
 * Updates one or more notification preferences for the authenticated user. At least one field must be provided.
 */
export const updateNotificationPreferencesMutation = (
  options?: Partial<Options<UpdateNotificationPreferencesData>>,
): UseMutationOptions<
  UpdateNotificationPreferencesResponse,
  UpdateNotificationPreferencesError,
  Options<UpdateNotificationPreferencesData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateNotificationPreferencesResponse,
    UpdateNotificationPreferencesError,
    Options<UpdateNotificationPreferencesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateNotificationPreferences({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Mark a single notification as read
 *
 * Marks a specific notification as read by its ID.
 */
export const markNotificationReadMutation = (
  options?: Partial<Options<MarkNotificationReadData>>,
): UseMutationOptions<
  MarkNotificationReadResponse,
  MarkNotificationReadError,
  Options<MarkNotificationReadData>
> => {
  const mutationOptions: UseMutationOptions<
    MarkNotificationReadResponse,
    MarkNotificationReadError,
    Options<MarkNotificationReadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await markNotificationRead({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a notification
 *
 * Soft-deletes a notification by its ID.
 */
export const deleteNotificationMutation = (
  options?: Partial<Options<DeleteNotificationData>>,
): UseMutationOptions<
  DeleteNotificationResponse,
  DeleteNotificationError,
  Options<DeleteNotificationData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteNotificationResponse,
    DeleteNotificationError,
    Options<DeleteNotificationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteNotification({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const searchQueryKey = (options?: Options<SearchData>) =>
  createQueryKey("search", options);

/**
 * Search across projects and workflows
 */
export const searchOptions = (options?: Options<SearchData>) =>
  queryOptions<
    SearchResponse,
    SearchError,
    SearchResponse,
    ReturnType<typeof searchQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await search({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: searchQueryKey(options),
  });

export const searchInfiniteQueryKey = (
  options?: Options<SearchData>,
): QueryKey<Options<SearchData>> => createQueryKey("search", options, true);

/**
 * Search across projects and workflows
 */
export const searchInfiniteOptions = (options?: Options<SearchData>) =>
  infiniteQueryOptions<
    SearchResponse,
    SearchError,
    InfiniteData<SearchResponse>,
    QueryKey<Options<SearchData>>,
    | number
    | Pick<
        QueryKey<Options<SearchData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SearchData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await search({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: searchInfiniteQueryKey(options),
    },
  );

export const getSearchFiltersQueryKey = (
  options?: Options<GetSearchFiltersData>,
) => createQueryKey("getSearchFilters", options);

/**
 * Get available search filter dimensions and values
 */
export const getSearchFiltersOptions = (
  options?: Options<GetSearchFiltersData>,
) =>
  queryOptions<
    GetSearchFiltersResponse,
    GetSearchFiltersError,
    GetSearchFiltersResponse,
    ReturnType<typeof getSearchFiltersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSearchFilters({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSearchFiltersQueryKey(options),
  });

export const listBinItemsQueryKey = (options?: Options<ListBinItemsData>) =>
  createQueryKey("listBinItems", options);

/**
 * List bin items (soft-deleted entities)
 *
 * Returns all soft-deleted entities (projects, workflows, assets) in the
 * user's bin, enriched with entity names, thumbnails, and deletion metadata.
 * Items are ordered by deletion date (newest first).
 *
 */
export const listBinItemsOptions = (options?: Options<ListBinItemsData>) =>
  queryOptions<
    ListBinItemsResponse,
    ListBinItemsError,
    ListBinItemsResponse,
    ReturnType<typeof listBinItemsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listBinItems({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listBinItemsQueryKey(options),
  });

export const listCredentialsQueryKey = (
  options?: Options<ListCredentialsData>,
) => createQueryKey("listCredentials", options);

/**
 * List credentials (metadata only)
 *
 * Returns all credentials owned by the caller's organisation. Encrypted
 * secret material is never returned — only metadata such as name, provider
 * type, status, and timestamps.
 *
 */
export const listCredentialsOptions = (
  options?: Options<ListCredentialsData>,
) =>
  queryOptions<
    ListCredentialsResponse,
    ListCredentialsError,
    ListCredentialsResponse,
    ReturnType<typeof listCredentialsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listCredentials({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listCredentialsQueryKey(options),
  });

/**
 * Create encrypted credential
 *
 * Stores an API key for an external provider, encrypted at rest. The
 * plaintext key is never returned in any subsequent response.
 *
 */
export const createCredentialMutation = (
  options?: Partial<Options<CreateCredentialData>>,
): UseMutationOptions<
  CreateCredentialResponse2,
  CreateCredentialError,
  Options<CreateCredentialData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateCredentialResponse2,
    CreateCredentialError,
    Options<CreateCredentialData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createCredential({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Soft-delete (revoke) credential
 */
export const deleteCredentialMutation = (
  options?: Partial<Options<DeleteCredentialData>>,
): UseMutationOptions<
  DeleteCredentialResponse2,
  DeleteCredentialError,
  Options<DeleteCredentialData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteCredentialResponse2,
    DeleteCredentialError,
    Options<DeleteCredentialData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteCredential({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listCustomServicesQueryKey = (
  options?: Options<ListCustomServicesData>,
) => createQueryKey("listCustomServices", options);

/**
 * List custom services for caller's organisation
 */
export const listCustomServicesOptions = (
  options?: Options<ListCustomServicesData>,
) =>
  queryOptions<
    ListCustomServicesResponse,
    ListCustomServicesError,
    ListCustomServicesResponse,
    ReturnType<typeof listCustomServicesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listCustomServices({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listCustomServicesQueryKey(options),
  });

/**
 * Create draft custom service
 *
 * Creates a new custom-service draft. Inference may be started subsequently
 * via `POST /v1/custom-services/{id}/infer`.
 *
 */
export const createCustomServiceMutation = (
  options?: Partial<Options<CreateCustomServiceData>>,
): UseMutationOptions<
  CreateCustomServiceResponse2,
  CreateCustomServiceError,
  Options<CreateCustomServiceData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateCustomServiceResponse2,
    CreateCustomServiceError,
    Options<CreateCustomServiceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createCustomService({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCustomServiceQueryKey = (
  options: Options<GetCustomServiceData>,
) => createQueryKey("getCustomService", options);

/**
 * Get single custom service
 */
export const getCustomServiceOptions = (
  options: Options<GetCustomServiceData>,
) =>
  queryOptions<
    GetCustomServiceResponse,
    GetCustomServiceError,
    GetCustomServiceResponse,
    ReturnType<typeof getCustomServiceQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCustomService({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCustomServiceQueryKey(options),
  });

/**
 * Update draft fields
 */
export const updateCustomServiceMutation = (
  options?: Partial<Options<UpdateCustomServiceData>>,
): UseMutationOptions<
  UpdateCustomServiceResponse2,
  UpdateCustomServiceError,
  Options<UpdateCustomServiceData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateCustomServiceResponse2,
    UpdateCustomServiceError,
    Options<UpdateCustomServiceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateCustomService({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Transition custom service from Draft to Active
 */
export const activateCustomServiceMutation = (
  options?: Partial<Options<ActivateCustomServiceData>>,
): UseMutationOptions<
  ActivateCustomServiceResponse,
  ActivateCustomServiceError,
  Options<ActivateCustomServiceData>
> => {
  const mutationOptions: UseMutationOptions<
    ActivateCustomServiceResponse,
    ActivateCustomServiceError,
    Options<ActivateCustomServiceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await activateCustomService({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Transition custom service from Active to Disabled
 */
export const disableCustomServiceMutation = (
  options?: Partial<Options<DisableCustomServiceData>>,
): UseMutationOptions<
  DisableCustomServiceResponse,
  DisableCustomServiceError,
  Options<DisableCustomServiceData>
> => {
  const mutationOptions: UseMutationOptions<
    DisableCustomServiceResponse,
    DisableCustomServiceError,
    Options<DisableCustomServiceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await disableCustomService({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Start the 6-phase inference engine
 *
 * Enqueues the inference job to the orchestrator. Progress and questions
 * are published via the WebSocket channel `custom-service.infer.*`.
 *
 */
export const startCustomServiceInferenceMutation = (
  options?: Partial<Options<StartCustomServiceInferenceData>>,
): UseMutationOptions<
  StartCustomServiceInferenceResponse,
  StartCustomServiceInferenceError,
  Options<StartCustomServiceInferenceData>
> => {
  const mutationOptions: UseMutationOptions<
    StartCustomServiceInferenceResponse,
    StartCustomServiceInferenceError,
    Options<StartCustomServiceInferenceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await startCustomServiceInference({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Answer an inference question
 *
 * Records an answer to an outstanding inference question and unblocks the
 * waiting orchestrator worker.
 *
 */
export const answerInferenceQuestionMutation = (
  options?: Partial<Options<AnswerInferenceQuestionData>>,
): UseMutationOptions<
  AnswerInferenceQuestionResponse2,
  AnswerInferenceQuestionError,
  Options<AnswerInferenceQuestionData>
> => {
  const mutationOptions: UseMutationOptions<
    AnswerInferenceQuestionResponse2,
    AnswerInferenceQuestionError,
    Options<AnswerInferenceQuestionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await answerInferenceQuestion({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Preview a custom-service invocation (ephemeral, no persistence)
 *
 * Issues a one-shot request to the configured endpoint with the supplied
 * test inputs and parameter overrides, returning the raw + mapped response
 * for inspection. Nothing is persisted.
 *
 */
export const previewCustomServiceMutation = (
  options?: Partial<Options<PreviewCustomServiceData>>,
): UseMutationOptions<
  PreviewCustomServiceResponse2,
  PreviewCustomServiceError,
  Options<PreviewCustomServiceData>
> => {
  const mutationOptions: UseMutationOptions<
    PreviewCustomServiceResponse2,
    PreviewCustomServiceError,
    Options<PreviewCustomServiceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await previewCustomService({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getScenesQueryKey = (options: Options<GetScenesData>) =>
  createQueryKey("getScenes", options);

/**
 * List scenes for a project
 */
export const getScenesOptions = (options: Options<GetScenesData>) =>
  queryOptions<
    GetScenesResponse,
    GetScenesError,
    GetScenesResponse,
    ReturnType<typeof getScenesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getScenes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getScenesQueryKey(options),
  });

/**
 * Create a scene
 */
export const createSceneMutation = (
  options?: Partial<Options<CreateSceneData>>,
): UseMutationOptions<
  CreateSceneResponse,
  CreateSceneError,
  Options<CreateSceneData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateSceneResponse,
    CreateSceneError,
    Options<CreateSceneData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createScene({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Reorder scenes within a project
 */
export const reorderScenesMutation = (
  options?: Partial<Options<ReorderScenesData>>,
): UseMutationOptions<
  ReorderScenesResponse,
  ReorderScenesError,
  Options<ReorderScenesData>
> => {
  const mutationOptions: UseMutationOptions<
    ReorderScenesResponse,
    ReorderScenesError,
    Options<ReorderScenesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await reorderScenes({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a scene
 */
export const deleteSceneMutation = (
  options?: Partial<Options<DeleteSceneData>>,
): UseMutationOptions<
  DeleteSceneResponse,
  DeleteSceneError,
  Options<DeleteSceneData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteSceneResponse,
    DeleteSceneError,
    Options<DeleteSceneData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteScene({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update a scene
 */
export const updateSceneMutation = (
  options?: Partial<Options<UpdateSceneData>>,
): UseMutationOptions<
  UpdateSceneResponse,
  UpdateSceneError,
  Options<UpdateSceneData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateSceneResponse,
    UpdateSceneError,
    Options<UpdateSceneData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateScene({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create a shot
 */
export const createShotMutation = (
  options?: Partial<Options<CreateShotData>>,
): UseMutationOptions<
  CreateShotResponse,
  CreateShotError,
  Options<CreateShotData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateShotResponse,
    CreateShotError,
    Options<CreateShotData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createShot({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Reorder shots across scenes within a project
 */
export const reorderShotsMutation = (
  options?: Partial<Options<ReorderShotsData>>,
): UseMutationOptions<
  ReorderShotsResponse,
  ReorderShotsError,
  Options<ReorderShotsData>
> => {
  const mutationOptions: UseMutationOptions<
    ReorderShotsResponse,
    ReorderShotsError,
    Options<ReorderShotsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await reorderShots({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a shot
 */
export const deleteShotMutation = (
  options?: Partial<Options<DeleteShotData>>,
): UseMutationOptions<
  DeleteShotResponse,
  DeleteShotError,
  Options<DeleteShotData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteShotResponse,
    DeleteShotError,
    Options<DeleteShotData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteShot({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getShotQueryKey = (options: Options<GetShotData>) =>
  createQueryKey("getShot", options);

/**
 * Get shot details
 */
export const getShotOptions = (options: Options<GetShotData>) =>
  queryOptions<
    GetShotResponse,
    GetShotError,
    GetShotResponse,
    ReturnType<typeof getShotQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getShot({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getShotQueryKey(options),
  });

/**
 * Update a shot
 */
export const updateShotMutation = (
  options?: Partial<Options<UpdateShotData>>,
): UseMutationOptions<
  UpdateShotResponse,
  UpdateShotError,
  Options<UpdateShotData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateShotResponse,
    UpdateShotError,
    Options<UpdateShotData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateShot({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getShotAssetsQueryKey = (options: Options<GetShotAssetsData>) =>
  createQueryKey("getShotAssets", options);

/**
 * List assets attached to a shot
 */
export const getShotAssetsOptions = (options: Options<GetShotAssetsData>) =>
  queryOptions<
    GetShotAssetsResponse,
    GetShotAssetsError,
    GetShotAssetsResponse,
    ReturnType<typeof getShotAssetsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getShotAssets({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getShotAssetsQueryKey(options),
  });

/**
 * Attach an asset to a shot
 */
export const addShotAssetMutation = (
  options?: Partial<Options<AddShotAssetData>>,
): UseMutationOptions<
  AddShotAssetResponse,
  AddShotAssetError,
  Options<AddShotAssetData>
> => {
  const mutationOptions: UseMutationOptions<
    AddShotAssetResponse,
    AddShotAssetError,
    Options<AddShotAssetData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await addShotAsset({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Detach an asset from a shot
 */
export const removeShotAssetMutation = (
  options?: Partial<Options<RemoveShotAssetData>>,
): UseMutationOptions<
  RemoveShotAssetResponse,
  RemoveShotAssetError,
  Options<RemoveShotAssetData>
> => {
  const mutationOptions: UseMutationOptions<
    RemoveShotAssetResponse,
    RemoveShotAssetError,
    Options<RemoveShotAssetData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeShotAsset({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Approve an asset
 */
export const approveAssetMutation = (
  options?: Partial<Options<ApproveAssetData>>,
): UseMutationOptions<
  ApproveAssetResponse,
  ApproveAssetError,
  Options<ApproveAssetData>
> => {
  const mutationOptions: UseMutationOptions<
    ApproveAssetResponse,
    ApproveAssetError,
    Options<ApproveAssetData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await approveAsset({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Unapprove an asset
 */
export const unapproveAssetMutation = (
  options?: Partial<Options<UnapproveAssetData>>,
): UseMutationOptions<
  UnapproveAssetResponse,
  UnapproveAssetError,
  Options<UnapproveAssetData>
> => {
  const mutationOptions: UseMutationOptions<
    UnapproveAssetResponse,
    UnapproveAssetError,
    Options<UnapproveAssetData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await unapproveAsset({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCreativeDirectionQueryKey = (
  options: Options<GetCreativeDirectionData>,
) => createQueryKey("getCreativeDirection", options);

/**
 * Get creative direction for a shot
 */
export const getCreativeDirectionOptions = (
  options: Options<GetCreativeDirectionData>,
) =>
  queryOptions<
    GetCreativeDirectionResponse,
    GetCreativeDirectionError,
    GetCreativeDirectionResponse,
    ReturnType<typeof getCreativeDirectionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCreativeDirection({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCreativeDirectionQueryKey(options),
  });

/**
 * Update creative direction for a shot
 */
export const updateCreativeDirectionMutation = (
  options?: Partial<Options<UpdateCreativeDirectionData>>,
): UseMutationOptions<
  UpdateCreativeDirectionResponse,
  UpdateCreativeDirectionError,
  Options<UpdateCreativeDirectionData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateCreativeDirectionResponse,
    UpdateCreativeDirectionError,
    Options<UpdateCreativeDirectionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateCreativeDirection({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Lock creative direction for a shot
 */
export const lockCreativeDirectionMutation = (
  options?: Partial<Options<LockCreativeDirectionData>>,
): UseMutationOptions<
  LockCreativeDirectionResponse,
  LockCreativeDirectionError,
  Options<LockCreativeDirectionData>
> => {
  const mutationOptions: UseMutationOptions<
    LockCreativeDirectionResponse,
    LockCreativeDirectionError,
    Options<LockCreativeDirectionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await lockCreativeDirection({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Unlock creative direction for a shot
 */
export const unlockCreativeDirectionMutation = (
  options?: Partial<Options<UnlockCreativeDirectionData>>,
): UseMutationOptions<
  UnlockCreativeDirectionResponse,
  UnlockCreativeDirectionError,
  Options<UnlockCreativeDirectionData>
> => {
  const mutationOptions: UseMutationOptions<
    UnlockCreativeDirectionResponse,
    UnlockCreativeDirectionError,
    Options<UnlockCreativeDirectionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await unlockCreativeDirection({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getShotAuditQueryKey = (options: Options<GetShotAuditData>) =>
  createQueryKey("getShotAudit", options);

/**
 * Get audit history for a shot
 */
export const getShotAuditOptions = (options: Options<GetShotAuditData>) =>
  queryOptions<
    GetShotAuditResponse,
    GetShotAuditError,
    GetShotAuditResponse,
    ReturnType<typeof getShotAuditQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getShotAudit({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getShotAuditQueryKey(options),
  });

export const getShotAuditInfiniteQueryKey = (
  options: Options<GetShotAuditData>,
): QueryKey<Options<GetShotAuditData>> =>
  createQueryKey("getShotAudit", options, true);

/**
 * Get audit history for a shot
 */
export const getShotAuditInfiniteOptions = (
  options: Options<GetShotAuditData>,
) =>
  infiniteQueryOptions<
    GetShotAuditResponse,
    GetShotAuditError,
    InfiniteData<GetShotAuditResponse>,
    QueryKey<Options<GetShotAuditData>>,
    | number
    | Pick<
        QueryKey<Options<GetShotAuditData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetShotAuditData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getShotAudit({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getShotAuditInfiniteQueryKey(options),
    },
  );

export const getShotNodesQueryKey = (options: Options<GetShotNodesData>) =>
  createQueryKey("getShotNodes", options);

/**
 * List nodes for a shot
 */
export const getShotNodesOptions = (options: Options<GetShotNodesData>) =>
  queryOptions<
    GetShotNodesResponse,
    GetShotNodesError,
    GetShotNodesResponse,
    ReturnType<typeof getShotNodesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getShotNodes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getShotNodesQueryKey(options),
  });

export const getShotNodeDetailQueryKey = (
  options: Options<GetShotNodeDetailData>,
) => createQueryKey("getShotNodeDetail", options);

/**
 * Get detail for a single shot node
 */
export const getShotNodeDetailOptions = (
  options: Options<GetShotNodeDetailData>,
) =>
  queryOptions<
    GetShotNodeDetailResponse,
    GetShotNodeDetailError,
    GetShotNodeDetailResponse,
    ReturnType<typeof getShotNodeDetailQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getShotNodeDetail({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getShotNodeDetailQueryKey(options),
  });

/**
 * Update settings for a shot node
 */
export const updateShotNodeMutation = (
  options?: Partial<Options<UpdateShotNodeData>>,
): UseMutationOptions<
  UpdateShotNodeResponse,
  UpdateShotNodeError,
  Options<UpdateShotNodeData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateShotNodeResponse,
    UpdateShotNodeError,
    Options<UpdateShotNodeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateShotNode({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Run a shot node
 */
export const runShotNodeMutation = (
  options?: Partial<Options<RunShotNodeData>>,
): UseMutationOptions<
  RunShotNodeResponse,
  RunShotNodeError,
  Options<RunShotNodeData>
> => {
  const mutationOptions: UseMutationOptions<
    RunShotNodeResponse,
    RunShotNodeError,
    Options<RunShotNodeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await runShotNode({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getWorkflowTemplatesQueryKey = (
  options: Options<GetWorkflowTemplatesData>,
) => createQueryKey("getWorkflowTemplates", options);

/**
 * List workflow templates available to a project
 */
export const getWorkflowTemplatesOptions = (
  options: Options<GetWorkflowTemplatesData>,
) =>
  queryOptions<
    GetWorkflowTemplatesResponse,
    GetWorkflowTemplatesError,
    GetWorkflowTemplatesResponse,
    ReturnType<typeof getWorkflowTemplatesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWorkflowTemplates({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getWorkflowTemplatesQueryKey(options),
  });

/**
 * Mark or unmark a workflow as a shot template
 */
export const setWorkflowShotTemplateMutation = (
  options?: Partial<Options<SetWorkflowShotTemplateData>>,
): UseMutationOptions<
  SetWorkflowShotTemplateResponse,
  SetWorkflowShotTemplateError,
  Options<SetWorkflowShotTemplateData>
> => {
  const mutationOptions: UseMutationOptions<
    SetWorkflowShotTemplateResponse,
    SetWorkflowShotTemplateError,
    Options<SetWorkflowShotTemplateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await setWorkflowShotTemplate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listLorasQueryKey = (options?: Options<ListLorasData>) =>
  createQueryKey("listLoras", options);

/**
 * List LoRAs visible to the caller (owned + team-shared)
 */
export const listLorasOptions = (options?: Options<ListLorasData>) =>
  queryOptions<
    ListLorasResponse,
    ListLorasError,
    ListLorasResponse,
    ReturnType<typeof listLorasQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listLoras({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listLorasQueryKey(options),
  });

/**
 * Create a LoRA + its auto-managed hidden dataset project
 */
export const createLoraMutation = (
  options?: Partial<Options<CreateLoraData>>,
): UseMutationOptions<
  CreateLoraResponse,
  CreateLoraError,
  Options<CreateLoraData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateLoraResponse,
    CreateLoraError,
    Options<CreateLoraData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createLora({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Archive a LoRA (soft delete; cascades to dataset project)
 */
export const deleteLoraMutation = (
  options?: Partial<Options<DeleteLoraData>>,
): UseMutationOptions<
  DeleteLoraResponse,
  DeleteLoraError,
  Options<DeleteLoraData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteLoraResponse,
    DeleteLoraError,
    Options<DeleteLoraData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteLora({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getLoraQueryKey = (options: Options<GetLoraData>) =>
  createQueryKey("getLora", options);

/**
 * Get LoRA detail with embedded trainingRuns + checkpoints
 */
export const getLoraOptions = (options: Options<GetLoraData>) =>
  queryOptions<
    GetLoraResponse,
    GetLoraError,
    GetLoraResponse,
    ReturnType<typeof getLoraQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLora({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLoraQueryKey(options),
  });

/**
 * Update a LoRA (name / description / trigger word / cover asset)
 */
export const updateLoraMutation = (
  options?: Partial<Options<UpdateLoraData>>,
): UseMutationOptions<
  UpdateLoraResponse,
  UpdateLoraError,
  Options<UpdateLoraData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateLoraResponse,
    UpdateLoraError,
    Options<UpdateLoraData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateLora({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Transfer LoRA ownership from user-private to team-shared
 */
export const transferLoraToTeamMutation = (
  options?: Partial<Options<TransferLoraToTeamData>>,
): UseMutationOptions<
  TransferLoraToTeamResponse,
  TransferLoraToTeamError,
  Options<TransferLoraToTeamData>
> => {
  const mutationOptions: UseMutationOptions<
    TransferLoraToTeamResponse,
    TransferLoraToTeamError,
    Options<TransferLoraToTeamData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await transferLoraToTeam({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Transfer LoRA ownership from team-shared back to user-private
 */
export const transferLoraToUserMutation = (
  options?: Partial<Options<TransferLoraToUserData>>,
): UseMutationOptions<
  TransferLoraToUserResponse,
  TransferLoraToUserError,
  Options<TransferLoraToUserData>
> => {
  const mutationOptions: UseMutationOptions<
    TransferLoraToUserResponse,
    TransferLoraToUserError,
    Options<TransferLoraToUserData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await transferLoraToUser({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Pin a specific checkpoint as the LoRA's default inference target
 */
export const setDefaultCheckpointMutation = (
  options?: Partial<Options<SetDefaultCheckpointData>>,
): UseMutationOptions<
  SetDefaultCheckpointResponse,
  SetDefaultCheckpointError,
  Options<SetDefaultCheckpointData>
> => {
  const mutationOptions: UseMutationOptions<
    SetDefaultCheckpointResponse,
    SetDefaultCheckpointError,
    Options<SetDefaultCheckpointData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await setDefaultCheckpoint({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listLoraCheckpointsQueryKey = (
  options: Options<ListLoraCheckpointsData>,
) => createQueryKey("listLoraCheckpoints", options);

/**
 * List all checkpoints emitted across the LoRA's training runs
 */
export const listLoraCheckpointsOptions = (
  options: Options<ListLoraCheckpointsData>,
) =>
  queryOptions<
    ListLoraCheckpointsResponse,
    ListLoraCheckpointsError,
    ListLoraCheckpointsResponse,
    ReturnType<typeof listLoraCheckpointsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listLoraCheckpoints({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listLoraCheckpointsQueryKey(options),
  });

export const listLoraTrainingRunsQueryKey = (
  options: Options<ListLoraTrainingRunsData>,
) => createQueryKey("listLoraTrainingRuns", options);

/**
 * List a LoRA's training runs (most-recent first)
 */
export const listLoraTrainingRunsOptions = (
  options: Options<ListLoraTrainingRunsData>,
) =>
  queryOptions<
    ListLoraTrainingRunsResponse,
    ListLoraTrainingRunsError,
    ListLoraTrainingRunsResponse,
    ReturnType<typeof listLoraTrainingRunsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listLoraTrainingRuns({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listLoraTrainingRunsQueryKey(options),
  });

/**
 * Submit a new training run (enqueues orchestrator submit-lora-training action)
 */
export const submitLoraTrainingRunMutation = (
  options?: Partial<Options<SubmitLoraTrainingRunData>>,
): UseMutationOptions<
  SubmitLoraTrainingRunResponse,
  SubmitLoraTrainingRunError,
  Options<SubmitLoraTrainingRunData>
> => {
  const mutationOptions: UseMutationOptions<
    SubmitLoraTrainingRunResponse,
    SubmitLoraTrainingRunError,
    Options<SubmitLoraTrainingRunData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await submitLoraTrainingRun({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getLoraTrainingRunQueryKey = (
  options: Options<GetLoraTrainingRunData>,
) => createQueryKey("getLoraTrainingRun", options);

/**
 * Get a single training run with embedded checkpoints[]
 */
export const getLoraTrainingRunOptions = (
  options: Options<GetLoraTrainingRunData>,
) =>
  queryOptions<
    GetLoraTrainingRunResponse,
    GetLoraTrainingRunError,
    GetLoraTrainingRunResponse,
    ReturnType<typeof getLoraTrainingRunQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLoraTrainingRun({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLoraTrainingRunQueryKey(options),
  });

/**
 * Cancel an in-flight training run (enqueues cancel-lora-training action)
 */
export const cancelLoraTrainingRunMutation = (
  options?: Partial<Options<CancelLoraTrainingRunData>>,
): UseMutationOptions<
  CancelLoraTrainingRunResponse,
  CancelLoraTrainingRunError,
  Options<CancelLoraTrainingRunData>
> => {
  const mutationOptions: UseMutationOptions<
    CancelLoraTrainingRunResponse,
    CancelLoraTrainingRunError,
    Options<CancelLoraTrainingRunData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await cancelLoraTrainingRun({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listLoraBaseModelsQueryKey = (
  options?: Options<ListLoraBaseModelsData>,
) => createQueryKey("listLoraBaseModels", options);

/**
 * List base models available for LoRA training
 */
export const listLoraBaseModelsOptions = (
  options?: Options<ListLoraBaseModelsData>,
) =>
  queryOptions<
    ListLoraBaseModelsResponse,
    ListLoraBaseModelsError,
    ListLoraBaseModelsResponse,
    ReturnType<typeof listLoraBaseModelsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listLoraBaseModels({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listLoraBaseModelsQueryKey(options),
  });

export const listLoraKindsQueryKey = (options?: Options<ListLoraKindsData>) =>
  createQueryKey("listLoraKinds", options);

/**
 * List LoRA kinds (subject / style / concept)
 */
export const listLoraKindsOptions = (options?: Options<ListLoraKindsData>) =>
  queryOptions<
    ListLoraKindsResponse,
    ListLoraKindsError,
    ListLoraKindsResponse,
    ReturnType<typeof listLoraKindsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listLoraKinds({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listLoraKindsQueryKey(options),
  });

export const getLoraDatasetPrepQueryKey = (
  options: Options<GetLoraDatasetPrepData>,
) => createQueryKey("getLoraDatasetPrep", options);

/**
 * Current dataset-prep state (prep run + captions with signed URLs)
 *
 * Returns the active prep run plus each prepared caption augmented with a signed downloadUrl/thumbnailUrl, so the wizard's review grid does not need a separate assets fetch.
 */
export const getLoraDatasetPrepOptions = (
  options: Options<GetLoraDatasetPrepData>,
) =>
  queryOptions<
    GetLoraDatasetPrepResponse,
    GetLoraDatasetPrepError,
    GetLoraDatasetPrepResponse,
    ReturnType<typeof getLoraDatasetPrepQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLoraDatasetPrep({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLoraDatasetPrepQueryKey(options),
  });

/**
 * Start a dataset-prep run (caption + package the reference images)
 *
 * Generates and persists the hidden trigger label, creates a prep-run row, and enqueues a `prepare-lora-dataset` job. Idempotent per LoRA via a deterministic BullMQ jobId.
 */
export const startLoraDatasetPrepMutation = (
  options?: Partial<Options<StartLoraDatasetPrepData>>,
): UseMutationOptions<
  StartLoraDatasetPrepResponse,
  StartLoraDatasetPrepError,
  Options<StartLoraDatasetPrepData>
> => {
  const mutationOptions: UseMutationOptions<
    StartLoraDatasetPrepResponse,
    StartLoraDatasetPrepError,
    Options<StartLoraDatasetPrepData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await startLoraDatasetPrep({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Edit the caption for one prepared dataset asset
 */
export const updateLoraDatasetCaptionMutation = (
  options?: Partial<Options<UpdateLoraDatasetCaptionData>>,
): UseMutationOptions<
  UpdateLoraDatasetCaptionResponse,
  UpdateLoraDatasetCaptionError,
  Options<UpdateLoraDatasetCaptionData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateLoraDatasetCaptionResponse,
    UpdateLoraDatasetCaptionError,
    Options<UpdateLoraDatasetCaptionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateLoraDatasetCaption({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Idempotent status transition for a training run (orchestrator only)
 */
export const internalSetTrainingRunStatusMutation = (
  options?: Partial<Options<InternalSetTrainingRunStatusData>>,
): UseMutationOptions<
  InternalSetTrainingRunStatusResponse,
  InternalSetTrainingRunStatusError,
  Options<InternalSetTrainingRunStatusData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalSetTrainingRunStatusResponse,
    InternalSetTrainingRunStatusError,
    Options<InternalSetTrainingRunStatusData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalSetTrainingRunStatus({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Record the AWS Batch job id + ARN for a training run (orchestrator only)
 */
export const internalSetTrainingRunExternalJobMutation = (
  options?: Partial<Options<InternalSetTrainingRunExternalJobData>>,
): UseMutationOptions<
  InternalSetTrainingRunExternalJobResponse,
  InternalSetTrainingRunExternalJobError,
  Options<InternalSetTrainingRunExternalJobData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalSetTrainingRunExternalJobResponse,
    InternalSetTrainingRunExternalJobError,
    Options<InternalSetTrainingRunExternalJobData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalSetTrainingRunExternalJob({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Register a newly-uploaded checkpoint (orchestrator only)
 */
export const internalRegisterCheckpointMutation = (
  options?: Partial<Options<InternalRegisterCheckpointData>>,
): UseMutationOptions<
  InternalRegisterCheckpointResponse,
  InternalRegisterCheckpointError,
  Options<InternalRegisterCheckpointData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalRegisterCheckpointResponse,
    InternalRegisterCheckpointError,
    Options<InternalRegisterCheckpointData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalRegisterCheckpoint({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalGetTrainingRunQueryKey = (
  options: Options<InternalGetTrainingRunData>,
) => createQueryKey("internalGetTrainingRun", options);

/**
 * Orchestrator-facing read of a single training run (Phase 04 follow-up)
 */
export const internalGetTrainingRunOptions = (
  options: Options<InternalGetTrainingRunData>,
) =>
  queryOptions<
    InternalGetTrainingRunResponse,
    InternalGetTrainingRunError,
    InternalGetTrainingRunResponse,
    ReturnType<typeof internalGetTrainingRunQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalGetTrainingRun({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalGetTrainingRunQueryKey(options),
  });

export const internalListNonTerminalTrainingRunsQueryKey = (
  options?: Options<InternalListNonTerminalTrainingRunsData>,
) => createQueryKey("internalListNonTerminalTrainingRuns", options);

/**
 * List every training run in a non-terminal status (Phase 05 follow-up)
 */
export const internalListNonTerminalTrainingRunsOptions = (
  options?: Options<InternalListNonTerminalTrainingRunsData>,
) =>
  queryOptions<
    InternalListNonTerminalTrainingRunsResponse,
    InternalListNonTerminalTrainingRunsError,
    InternalListNonTerminalTrainingRunsResponse,
    ReturnType<typeof internalListNonTerminalTrainingRunsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalListNonTerminalTrainingRuns({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalListNonTerminalTrainingRunsQueryKey(options),
  });

/**
 * Record terminal completion of a training run (Phase 05 follow-up)
 */
export const internalFinalizeTrainingRunMutation = (
  options?: Partial<Options<InternalFinalizeTrainingRunData>>,
): UseMutationOptions<
  InternalFinalizeTrainingRunResponse,
  InternalFinalizeTrainingRunError,
  Options<InternalFinalizeTrainingRunData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalFinalizeTrainingRunResponse,
    InternalFinalizeTrainingRunError,
    Options<InternalFinalizeTrainingRunData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalFinalizeTrainingRun({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const internalGetLoraQueryKey = (
  options: Options<InternalGetLoraData>,
) => createQueryKey("internalGetLora", options);

/**
 * Orchestrator-facing read of a single LoRA by id (Phase 07 follow-up)
 */
export const internalGetLoraOptions = (options: Options<InternalGetLoraData>) =>
  queryOptions<
    InternalGetLoraResponse,
    InternalGetLoraError,
    InternalGetLoraResponse,
    ReturnType<typeof internalGetLoraQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalGetLora({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalGetLoraQueryKey(options),
  });

export const internalGetLoraCheckpointQueryKey = (
  options: Options<InternalGetLoraCheckpointData>,
) => createQueryKey("internalGetLoraCheckpoint", options);

/**
 * Orchestrator-facing read of a single checkpoint with asset.filePath denormalised (Phase 07 follow-up)
 */
export const internalGetLoraCheckpointOptions = (
  options: Options<InternalGetLoraCheckpointData>,
) =>
  queryOptions<
    InternalGetLoraCheckpointResponse,
    InternalGetLoraCheckpointError,
    InternalGetLoraCheckpointResponse,
    ReturnType<typeof internalGetLoraCheckpointQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalGetLoraCheckpoint({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: internalGetLoraCheckpointQueryKey(options),
  });

/**
 * Revoke consent-gated support access for the ticket's project
 *
 * The customer revokes consent for one of their own tickets — closes the open consent record and withdraws the assignee's viewer grant. Idempotent.
 */
export const revokeProjectSupportAccessMutation = (
  options?: Partial<Options<RevokeProjectSupportAccessData>>,
): UseMutationOptions<
  RevokeProjectSupportAccessResponse,
  RevokeProjectSupportAccessError,
  Options<RevokeProjectSupportAccessData>
> => {
  const mutationOptions: UseMutationOptions<
    RevokeProjectSupportAccessResponse,
    RevokeProjectSupportAccessError,
    Options<RevokeProjectSupportAccessData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await revokeProjectSupportAccess({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Grant consent-gated support access to the ticket's project
 *
 * The customer grants consent for Studio1 Support to view the project attached to one of their own open support tickets. On success a project-scoped notification is sent back to the granting customer.
 */
export const grantProjectSupportAccessMutation = (
  options?: Partial<Options<GrantProjectSupportAccessData>>,
): UseMutationOptions<
  GrantProjectSupportAccessResponse,
  GrantProjectSupportAccessError,
  Options<GrantProjectSupportAccessData>
> => {
  const mutationOptions: UseMutationOptions<
    GrantProjectSupportAccessResponse,
    GrantProjectSupportAccessError,
    Options<GrantProjectSupportAccessData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await grantProjectSupportAccess({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Expire lapsed support-access grants (orchestrator sweep only)
 *
 * TTL-backstop sweep (service-token only): closes OPEN support-access grants past their expiry and withdraws the assignee's viewer grant. Called by the orchestrator loop; never exposed on a user-authorizable path.
 */
export const internalExpireLapsedSupportGrantsMutation = (
  options?: Partial<Options<InternalExpireLapsedSupportGrantsData>>,
): UseMutationOptions<
  InternalExpireLapsedSupportGrantsResponse,
  InternalExpireLapsedSupportGrantsError,
  Options<InternalExpireLapsedSupportGrantsData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalExpireLapsedSupportGrantsResponse,
    InternalExpireLapsedSupportGrantsError,
    Options<InternalExpireLapsedSupportGrantsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalExpireLapsedSupportGrants({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};
